// GENERADO por scripts/build_translations.py — edita el contenido EN en ese script y vuelve a ejecutarlo.

export const LANG_OPTIONS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "pl", label: "Polski" },
  { code: "it", label: "Italiano" },
  { code: "fr", label: "Français" },
  { code: "pt", label: "Português" },
  { code: "uk", label: "Українська" },
  { code: "ro", label: "Română" },
  { code: "zh", label: "中文" },
  { code: "hi", label: "हिन्दी" },
];

export const translations = {
  en: {
    "meta": {
      "title": "24/7 Emergency Locksmith Edinburgh | UNLockSmiths",
      "description": "UNLockSmiths provides 24/7 written WhatsApp support for home, business and car lockouts in Edinburgh, Glasgow and surrounding areas. Message us with your location and photos."
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "Available 24/7 — written WhatsApp support",
      "line1": "Locked out?",
      "line2": "Message UNLockSmiths",
      "line3": "now.",
      "sub1": "24/7 emergency locksmith support in Edinburgh, Glasgow and surrounding areas.",
      "sub2": "Send us your location and explain what happened. You can also send photos of the door, lock or vehicle. We reply in writing on WhatsApp.",
      "whatsapp": "Message us on WhatsApp",
      "quote": "Get a written quote",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "trust": [
        "Available 24/7",
        "Written WhatsApp support",
        "Price agreed before work starts"
      ],
      "priceLine": "Send a photo, get a clear written price before any work starts."
    },
    "video": {
      "title": "Locked out? Help is one message away.",
      "sub": "Watch how it works in 20 seconds: message us on WhatsApp, send your location and a photo, and agree the price in writing before we start.",
      "unmute": "Sound on",
      "mute": "Mute",
      "aria": "UNLockSmiths promo video: 24/7 emergency locksmith in Edinburgh — message us on WhatsApp"
    },
    "marquee": [
      "24/7 EMERGENCY LOCKSMITH EDINBURGH",
      "HOUSE · BUSINESS · CAR LOCKOUTS",
      "WRITTEN WHATSAPP SUPPORT",
      "EDINBURGH · GLASGOW · SURROUNDING AREAS",
      "PRICE AGREED BEFORE WORK STARTS",
      "LOCK CHANGES & REPAIRS",
      "INDEPENDENT & LOCAL"
    ],
    "services": {
      "title": "Our Locksmith Services",
      "sub": "Emergency locksmith help for homes, businesses and vehicles in Edinburgh, Glasgow and surrounding areas — arranged in writing on WhatsApp.",
      "categories": [
        {
          "id": "home",
          "title": "Home Locksmith",
          "desc": "House lockout in Edinburgh? Emergency door opening, lock changes and repairs for your home.",
          "items": [
            "House lockouts",
            "Emergency door opening",
            "Lock changes",
            "Lock repairs",
            "Lost key assistance",
            "Burglary repairs",
            "New lock installation"
          ]
        },
        {
          "id": "business",
          "title": "Business Locksmith",
          "desc": "Business lockout or commercial lock change — emergency access for offices and shops.",
          "items": [
            "Office lockouts",
            "Shop and business lockouts",
            "Commercial lock changes",
            "Lock repairs for businesses",
            "Emergency access for offices and shops"
          ]
        },
        {
          "id": "auto",
          "title": "Auto Locksmith",
          "desc": "Car lockout in Edinburgh or Glasgow? Vehicle entry when your keys are locked inside.",
          "items": [
            "Car lockouts",
            "Vehicle entry",
            "Keys locked inside the vehicle"
          ]
        }
      ],
      "book": "Message us about this"
    },
    "how": {
      "title": "How it works",
      "sub": "Three simple steps — everything in writing.",
      "steps": [
        {
          "title": "Message us on WhatsApp",
          "desc": "Tell us what happened and where you are."
        },
        {
          "title": "Send photos if helpful",
          "desc": "Send a photo of the door, lock or vehicle if it is safe to do so."
        },
        {
          "title": "Agree the price in writing",
          "desc": "No work starts until you agree the price."
        }
      ]
    },
    "trust": {
      "title": "Clear prices. Written communication. No pressure.",
      "body": "We explain the situation in writing before work starts. You agree the price before we begin. If you are unsure what service you need, message us and we will guide you.",
      "cta": "Contact us in writing"
    },
    "coverage": {
      "title": "Service areas",
      "sub": "We mainly serve Edinburgh, with availability in Glasgow and surrounding towns. Message us with your location and we will confirm whether we can help.",
      "main": "Main service area",
      "additional": "Also available in",
      "cta": "Not sure if we cover your area? Send us your location.",
      "ctaBtn": "Message us on WhatsApp"
    },
    "about": {
      "title": "An independent local locksmith",
      "p1": "UNLockSmiths is an independent self-employed locksmith service serving Edinburgh and surrounding areas.",
      "p2": "We work in writing: you explain the problem, send your location and photos, and we confirm the price before any work begins. Home, business and car lockouts, lock changes and repairs — day or night, subject to availability.",
      "overlay": "Keys locked in your car? Message us on WhatsApp.",
      "stats": [
        {
          "value": "24/7",
          "label": "emergency support, subject to availability"
        },
        {
          "value": "WhatsApp",
          "label": "written support — price agreed before work starts"
        }
      ]
    },
    "aboutMe": {
      "label": "About me",
      "title": "Meet your locksmith",
      "quote": "Hi, I'm Alfonso, your local Edinburgh locksmith. I agree the price with you in writing before I start, so there are no surprises."
    },
    "reviews": {
      "title": "Google reviews",
      "body": "Google reviews coming soon.",
      "note": "Our Google Business Profile is being verified. Once it is live, you will be able to read and leave reviews here.",
      "button": "Leave us a Google review"
    },
    "faq": {
      "title": "Frequently asked questions",
      "items": [
        {
          "id": "written",
          "q": "Do you provide written WhatsApp support?",
          "a": "Yes. You can explain your situation, send your location and share photos by WhatsApp."
        },
        {
          "id": "night",
          "q": "Do you work at night?",
          "a": "We provide emergency support 24/7, subject to availability in your area."
        },
        {
          "id": "request",
          "q": "How do I request help?",
          "a": "Message us on WhatsApp with your location and a description of the problem."
        },
        {
          "id": "photo",
          "q": "Do I need to send a photo?",
          "a": "A photo can help us understand the situation, but it is not always required."
        },
        {
          "id": "price",
          "q": "Will I know the price before work starts?",
          "a": "We explain the price before work starts. You agree before we begin."
        },
        {
          "id": "car",
          "q": "Can you open a locked car?",
          "a": "We provide car lockout assistance where available. We may ask for proof of ownership or permission before opening a vehicle."
        },
        {
          "id": "business",
          "q": "Do you serve businesses?",
          "a": "Yes. We help with office, shop and business lockouts where available."
        }
      ]
    },
    "contact": {
      "title": "Send your request in writing",
      "sub": "Fill this in and we will open WhatsApp with your details ready to send. You can attach photos in the chat.",
      "name": "Name",
      "phone": "WhatsApp number",
      "location": "Area or postcode",
      "issue": "What do you need help with?",
      "issueOptions": [
        "Locked out of my home",
        "Locked out of my business",
        "Locked out of my car",
        "Lock change or repair",
        "Burglary repair",
        "Lost keys",
        "Other"
      ],
      "message": "Describe what happened",
      "photoHint": "Have a photo? Attach it in the WhatsApp chat after sending — it helps us understand the situation.",
      "submit": "Send request by WhatsApp",
      "sending": "Preparing…",
      "successTitle": "Request ready",
      "successBody": "WhatsApp is opening with your details. Attach photos in the chat if helpful.",
      "errorTitle": "Something went wrong",
      "errorBody": "Please try again or message us directly on WhatsApp.",
      "whatsappCta": "WhatsApp us",
      "emailCta": "Send us an email",
      "photosCta": "Send photos on WhatsApp",
      "writingCta": "Contact us in writing",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "waPhotoMessage": "Hi! I'm sending photos of my door, lock or vehicle. My location is: ",
      "waLabels": {
        "intro": "Hi! I need a locksmith.",
        "name": "Name",
        "phone": "WhatsApp",
        "location": "Location",
        "issue": "Help needed",
        "message": "What happened"
      },
      "validation": {
        "name": "Please enter your name (min. 2 characters)",
        "phone": "Please enter a valid WhatsApp number",
        "message": "Please describe what happened (min. 5 characters)"
      }
    },
    "footer": {
      "tagline": "24/7 emergency locksmith support in Edinburgh, Glasgow and surrounding areas. Written WhatsApp support.",
      "contactTitle": "Contact",
      "coverageTitle": "Service areas",
      "aboutTitle": "About",
      "legal": "Independent sole trader locksmith service.",
      "legal2": "UNLockSmiths is an independent self-employed locksmith service serving Edinburgh and surrounding areas.",
      "rights": "All rights reserved.",
      "website": "Website"
    },
    "social": {
      "title": "Follow us and message us",
      "sub": "We are available 24 hours a day, 7 days a week for emergency locksmith services in Edinburgh, Glasgow and surrounding areas."
    },
    "chat": {
      "title": "UNLockSmiths Assistant",
      "subtitle": "Online — replies 24/7",
      "welcome": "Hi! I'm the UNLockSmiths assistant. Ask me anything: services, areas, availability…",
      "suggestions": [
        "Are you available now?",
        "Do you cover my area?",
        "How do I request help?"
      ],
      "placeholder": "Type your question…",
      "error": "Sorry, something went wrong. Try again or message us on WhatsApp.",
      "open": "Chat with our assistant"
    },
    "float": {
      "label": "Message us on WhatsApp",
      "waMessage": "Hi! I need a locksmith. My situation: "
    }
  },
  es: {
    "meta": {
      "title": "Cerrajero de emergencia 24/7 Edimburgo | UNLockSmiths",
      "description": "UNLockSmiths ofrece asistencia escrita por WhatsApp 24/7 para aperturas de viviendas, negocios y coches en Edimburgo, Glasgow y zonas cercanas. Envíanos tu ubicación y fotos."
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "Disponible 24/7 — asistencia escrita por WhatsApp",
      "line1": "¿Te has quedado fuera?",
      "line2": "Escribe a UNLockSmiths",
      "line3": "ahora.",
      "sub1": "Asistencia de cerrajería de emergencia 24/7 en Edimburgo, Glasgow y zonas cercanas.",
      "sub2": "Envíanos tu ubicación y explica lo que ha pasado. También puedes enviar fotos de la puerta, la cerradura o el vehículo. Respondemos por escrito en WhatsApp.",
      "whatsapp": "Escríbenos por WhatsApp",
      "quote": "Obtén un presupuesto por escrito",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "trust": [
        "Disponible 24/7",
        "Asistencia escrita por WhatsApp",
        "Precio acordado antes de empezar"
      ],
      "priceLine": "Envía una foto y recibe un precio claro por escrito antes de empezar cualquier trabajo."
    },
    "marquee": [
      "CERRAJERO DE EMERGENCIA 24/7 EDIMBURGO",
      "VIVIENDA · NEGOCIO · APERTURAS DE COCHES",
      "ASISTENCIA ESCRITA POR WHATSAPP",
      "EDIMBURGO · GLASGOW · ZONAS CERCANAS",
      "PRECIO ACORDADO ANTES DE EMPEZAR",
      "CAMBIO Y REPARACIÓN DE CERRADURAS",
      "INDEPENDIENTE Y LOCAL"
    ],
    "services": {
      "title": "Nuestros servicios de cerrajería",
      "sub": "Ayuda urgente de cerrajería para viviendas, negocios y vehículos en Edimburgo, Glasgow y zonas cercanas — gestionado por escrito en WhatsApp.",
      "categories": [
        {
          "id": "home",
          "title": "Cerrajería para el hogar",
          "desc": "¿Te has quedado fuera de casa en Edimburgo? Apertura urgente de puertas, cambio y reparación de cerraduras para tu vivienda.",
          "items": [
            "Aperturas de viviendas",
            "Apertura urgente de puertas",
            "Cambio de cerraduras",
            "Reparación de cerraduras",
            "Ayuda por pérdida de llaves",
            "Reparaciones tras robo",
            "Instalación de nuevas cerraduras"
          ]
        },
        {
          "id": "business",
          "title": "Cerrajería para negocios",
          "desc": "Apertura de negocio o cambio de cerraduras comerciales — acceso urgente para oficinas y tiendas.",
          "items": [
            "Aperturas de oficinas",
            "Aperturas de tiendas y negocios",
            "Cambio de cerraduras comerciales",
            "Reparación de cerraduras para negocios",
            "Acceso urgente para oficinas y tiendas"
          ]
        },
        {
          "id": "auto",
          "title": "Cerrajería del automóvil",
          "desc": "¿Te has quedado fuera del coche en Edimburgo o Glasgow? Apertura del vehículo cuando las llaves se quedan dentro.",
          "items": [
            "Aperturas de coches",
            "Apertura de vehículos",
            "Llaves cerradas dentro del vehículo"
          ]
        }
      ],
      "book": "Escríbenos sobre esto"
    },
    "how": {
      "title": "Cómo funciona",
      "sub": "Tres pasos sencillos — todo por escrito.",
      "steps": [
        {
          "title": "Escríbenos por WhatsApp",
          "desc": "Cuéntanos qué ha pasado y dónde estás."
        },
        {
          "title": "Envía fotos si ayudan",
          "desc": "Envía una foto de la puerta, la cerradura o el vehículo si es seguro hacerlo."
        },
        {
          "title": "Acordad el precio por escrito",
          "desc": "No se empieza ningún trabajo hasta que aceptes el precio."
        }
      ]
    },
    "trust": {
      "title": "Precios claros. Comunicación por escrito. Sin presión.",
      "body": "Explicamos la situación por escrito antes de empezar cualquier trabajo. Aceptas el precio antes de que comencemos. Si no tienes claro qué servicio necesitas, escríbenos y te orientaremos.",
      "cta": "Contáctanos por escrito"
    },
    "coverage": {
      "title": "Zonas de servicio",
      "sub": "Trabajamos principalmente en Edimburgo, con disponibilidad en Glasgow y localidades cercanas. Envíanos tu ubicación y te confirmaremos si podemos ayudarte.",
      "main": "Zona principal de servicio",
      "additional": "También disponible en",
      "cta": "¿No sabes si cubrimos tu zona? Envíanos tu ubicación.",
      "ctaBtn": "Escríbenos por WhatsApp"
    },
    "about": {
      "title": "Un cerrajero local independiente",
      "p1": "UNLockSmiths es un servicio de cerrajería independiente y autónomo que trabaja en Edimburgo y zonas cercanas.",
      "p2": "Trabajamos por escrito: explicas el problema, envías tu ubicación y fotos, y confirmamos el precio antes de empezar cualquier trabajo. Aperturas de viviendas, negocios y coches, cambios y reparaciones de cerraduras — de día o de noche, sujeto a disponibilidad.",
      "overlay": "¿Llaves dentro del coche? Escríbenos por WhatsApp.",
      "stats": [
        {
          "value": "24/7",
          "label": "asistencia de emergencia, sujeto a disponibilidad"
        },
        {
          "value": "WhatsApp",
          "label": "asistencia por escrito — precio acordado antes de empezar"
        }
      ]
    },
    "reviews": {
      "title": "Reseñas de Google",
      "body": "Reseñas de Google próximamente.",
      "note": "Nuestro Perfil de Empresa de Google está en proceso de verificación. Cuando esté activo, podrás leer y dejar reseñas aquí.",
      "button": "Déjanos una reseña en Google"
    },
    "faq": {
      "title": "Preguntas frecuentes",
      "items": [
        {
          "id": "written",
          "q": "¿Ofrecéis asistencia escrita por WhatsApp?",
          "a": "Sí. Puedes explicar tu situación, enviar tu ubicación y compartir fotos por WhatsApp."
        },
        {
          "id": "night",
          "q": "¿Trabajáis por la noche?",
          "a": "Ofrecemos asistencia de emergencia 24/7, sujeta a disponibilidad en tu zona."
        },
        {
          "id": "request",
          "q": "¿Cómo solicito ayuda?",
          "a": "Escríbenos por WhatsApp con tu ubicación y una descripción del problema."
        },
        {
          "id": "photo",
          "q": "¿Tengo que enviar una foto?",
          "a": "Una foto puede ayudarnos a entender la situación, pero no siempre es necesaria."
        },
        {
          "id": "price",
          "q": "¿Sabré el precio antes de que empiece el trabajo?",
          "a": "Te explicamos el precio antes de empezar. Tú lo aceptas antes de que comencemos."
        },
        {
          "id": "car",
          "q": "¿Podéis abrir un coche cerrado?",
          "a": "Ofrecemos ayuda para aperturas de coches donde esté disponible. Podemos pedir prueba de propiedad o autorización antes de abrir un vehículo."
        },
        {
          "id": "business",
          "q": "¿Atendéis a negocios?",
          "a": "Sí. Ayudamos con aperturas de oficinas, tiendas y negocios donde esté disponible."
        }
      ]
    },
    "contact": {
      "title": "Envía tu solicitud por escrito",
      "sub": "Rellena esto y abriremos WhatsApp con tus datos listos para enviar. Puedes adjuntar fotos en el chat.",
      "name": "Nombre",
      "phone": "Número de WhatsApp",
      "location": "Zona o código postal",
      "issue": "¿Con qué necesitas ayuda?",
      "issueOptions": [
        "Me he quedado fuera de casa",
        "Me he quedado fuera de mi negocio",
        "Me he quedado fuera de mi coche",
        "Cambio o reparación de cerradura",
        "Reparación tras robo",
        "Llaves perdidas",
        "Otro"
      ],
      "message": "Describe lo que ha pasado",
      "photoHint": "¿Tienes una foto? Adjústala en el chat de WhatsApp después de enviar — nos ayuda a entender la situación.",
      "submit": "Enviar solicitud por WhatsApp",
      "sending": "Preparando…",
      "successTitle": "Solicitud lista",
      "successBody": "WhatsApp se está abriendo con tus datos. Adjunta fotos en el chat si ayudan.",
      "errorTitle": "Algo ha salido mal",
      "errorBody": "Vuelve a intentarlo o escríbenos directamente por WhatsApp.",
      "whatsappCta": "Escríbenos por WhatsApp",
      "emailCta": "Envíanos un correo electrónico",
      "photosCta": "Envía fotos por WhatsApp",
      "writingCta": "Contáctanos por escrito",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "waPhotoMessage": "Hi! I'm sending photos of my door, lock or vehicle. My location is: ",
      "waLabels": {
        "intro": "¡Hola! Necesito un cerrajero.",
        "name": "Nombre",
        "phone": "WhatsApp",
        "location": "Ubicación",
        "issue": "Ayuda necesaria",
        "message": "Qué ha pasado"
      },
      "validation": {
        "name": "Por favor, introduce tu nombre (mín. 2 caracteres)",
        "phone": "Por favor, introduce un número de WhatsApp válido",
        "message": "Por favor, describe qué ha pasado (mín. 5 caracteres)"
      }
    },
    "footer": {
      "tagline": "Asistencia de cerrajería de emergencia 24/7 en Edimburgo, Glasgow y zonas cercanas. Asistencia escrita por WhatsApp.",
      "contactTitle": "Contacto",
      "coverageTitle": "Zonas de servicio",
      "aboutTitle": "Sobre nosotros",
      "legal": "Servicio de cerrajería independiente por cuenta propia.",
      "legal2": "UNLockSmiths es un servicio de cerrajería independiente y autónomo que trabaja en Edimburgo y zonas cercanas.",
      "rights": "Todos los derechos reservados.",
      "website": "Sitio web"
    },
    "social": {
      "title": "Síguenos y escríbenos",
      "sub": "Estamos disponibles las 24 horas del día, los 7 días de la semana para servicios de cerrajería de emergencia en Edimburgo, Glasgow y zonas cercanas."
    },
    "chat": {
      "title": "Asistente de UNLockSmiths",
      "subtitle": "En línea — responde 24/7",
      "welcome": "¡Hola! Soy el asistente de UNLockSmiths. Pregúntame lo que quieras: servicios, zonas, disponibilidad…",
      "suggestions": [
        "¿Estáis disponibles ahora?",
        "¿Cubrís mi zona?",
        "¿Cómo solicito ayuda?"
      ],
      "placeholder": "Escribe tu pregunta…",
      "error": "Lo sentimos, algo ha salido mal. Vuelve a intentarlo o escríbenos por WhatsApp.",
      "open": "Chatea con nuestro asistente"
    },
    "float": {
      "label": "Escríbenos por WhatsApp",
      "waMessage": "Hi! I need a locksmith. My situation: "
    },
    "video": {
      "title": "¿Te has quedado fuera? La ayuda está a un mensaje.",
      "sub": "Mira cómo funciona en 20 segundos: escríbenos por WhatsApp, envía tu ubicación y una foto, y acuerda el precio por escrito antes de empezar.",
      "unmute": "Activar sonido",
      "mute": "Silenciar",
      "aria": "Vídeo promocional de UNLockSmiths: cerrajero de urgencias 24/7 en Edimburgo — escríbenos por WhatsApp"
    },
    "aboutMe": {
      "label": "Sobre mí",
      "title": "Conoce a tu cerrajero",
      "quote": "Hola, soy Alfonso, tu cerrajero local en Edimburgo. Acuerdo contigo el precio por escrito antes de empezar, para que no haya sorpresas."
    }
  },
  pl: {
    "meta": {
      "title": "Ślusarz awaryjny 24/7 Edinburgh | UNLockSmiths",
      "description": "UNLockSmiths zapewnia pisemne wsparcie przez WhatsApp 24/7 przy zatrzaśnięciach w domu, firmie i samochodzie w Edinburgh, Glasgow i okolicach. Wyślij nam swoją lokalizację i zdjęcia."
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "Dostępni 24/7 — pisemne wsparcie przez WhatsApp",
      "line1": "Zatrzasnąłeś się?",
      "line2": "Napisz do UNLockSmiths",
      "line3": "teraz.",
      "sub1": "Awaryjne wsparcie ślusarskie 24/7 w Edinburgh, Glasgow i okolicach.",
      "sub2": "Wyślij nam swoją lokalizację i opisz, co się stało. Możesz też przesłać zdjęcia drzwi, zamka lub pojazdu. Odpowiadamy pisemnie przez WhatsApp.",
      "whatsapp": "Napisz do nas na WhatsApp",
      "quote": "Uzyskaj wycenę na piśmie",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "trust": [
        "Dostępni 24/7",
        "Pisemne wsparcie przez WhatsApp",
        "Cena ustalona przed rozpoczęciem pracy"
      ],
      "priceLine": "Wyślij zdjęcie i otrzymaj jasną cenę na piśmie przed rozpoczęciem pracy."
    },
    "marquee": [
      "ŚLUSARZ AWARYJNY 24/7 EDINBURGH",
      "DOM · FIRMA · ZATRZAŚNIĘCIA W SAMOCHODZIE",
      "PISEMNE WSPARCIE PRZEZ WHATSAPP",
      "EDINBURGH · GLASGOW · OKOLICZNE OBSZARY",
      "CENA USTALONA PRZED ROZPOCZĘCIEM PRACY",
      "WYMIANA I NAPRAWA ZAMKÓW",
      "NIEZALEŻNY I LOKALNY"
    ],
    "services": {
      "title": "Nasze usługi ślusarskie",
      "sub": "Awaryjna pomoc ślusarska dla domów, firm i pojazdów w Edinburgh, Glasgow i okolicach — ustalana pisemnie przez WhatsApp.",
      "categories": [
        {
          "id": "home",
          "title": "Ślusarz domowy",
          "desc": "Zatrzaśnięcie w domu w Edinburgh? Awaryjne otwieranie drzwi, wymiana i naprawa zamków w Twoim domu.",
          "items": [
            "Zatrzaśnięcia w domu",
            "Awaryjne otwieranie drzwi",
            "Wymiana zamków",
            "Naprawa zamków",
            "Pomoc przy zgubionych kluczach",
            "Naprawy po włamaniu",
            "Montaż nowych zamków"
          ]
        },
        {
          "id": "business",
          "title": "Ślusarz dla firm",
          "desc": "Zatrzaśnięcie w firmie lub wymiana zamka komercyjnego — awaryjny dostęp do biur i sklepów.",
          "items": [
            "Zatrzaśnięcia w biurach",
            "Zatrzaśnięcia w sklepach i firmach",
            "Wymiana zamków komercyjnych",
            "Naprawa zamków dla firm",
            "Awaryjny dostęp do biur i sklepów"
          ]
        },
        {
          "id": "auto",
          "title": "Ślusarz samochodowy",
          "desc": "Zatrzaśnięcie samochodu w Edinburgh lub Glasgow? Otwieranie pojazdu, gdy kluczyki zostały w środku.",
          "items": [
            "Zatrzaśnięcia samochodu",
            "Otwarcie pojazdu",
            "Kluczyki zatrzaśnięte w pojeździe"
          ]
        }
      ],
      "book": "Napisz do nas w tej sprawie"
    },
    "how": {
      "title": "Jak to działa",
      "sub": "Trzy proste kroki — wszystko na piśmie.",
      "steps": [
        {
          "title": "Napisz do nas na WhatsApp",
          "desc": "Powiedz nam, co się stało i gdzie jesteś."
        },
        {
          "title": "Wyślij zdjęcia, jeśli pomogą",
          "desc": "Wyślij zdjęcie drzwi, zamka lub pojazdu, jeśli można to zrobić bezpiecznie."
        },
        {
          "title": "Ustal cenę na piśmie",
          "desc": "Nie zaczynamy pracy, dopóki nie zaakceptujesz ceny."
        }
      ]
    },
    "trust": {
      "title": "Jasne ceny. Pisemny kontakt. Bez nacisku.",
      "body": "Wyjaśniamy sytuację na piśmie przed rozpoczęciem pracy. Akceptujesz cenę, zanim zaczniemy. Jeśli nie masz pewności, jakiej usługi potrzebujesz, napisz do nas, a pokierujemy Cię.",
      "cta": "Skontaktuj się z nami na piśmie"
    },
    "coverage": {
      "title": "Obszary działania",
      "sub": "Działamy głównie w Edinburgh, z dostępnością w Glasgow i okolicznych miejscowościach. Wyślij nam swoją lokalizację, a potwierdzimy, czy możemy pomóc.",
      "main": "Główny obszar działania",
      "additional": "Dostępni również w",
      "cta": "Nie wiesz, czy obsługujemy Twoją okolicę? Wyślij nam swoją lokalizację.",
      "ctaBtn": "Napisz do nas na WhatsApp"
    },
    "about": {
      "title": "Niezależny lokalny ślusarz",
      "p1": "UNLockSmiths to niezależna, jednoosobowa usługa ślusarska działająca w Edinburgh i okolicach.",
      "p2": "Pracujemy na piśmie: opisujesz problem, wysyłasz swoją lokalizację i zdjęcia, a my potwierdzamy cenę przed rozpoczęciem jakiejkolwiek pracy. Zatrzaśnięcia w domu, firmie i samochodzie, wymiana i naprawa zamków — w dzień i w nocy, zależnie od dostępności.",
      "overlay": "Kluczyki zatrzaśnięte w samochodzie? Napisz do nas na WhatsApp.",
      "stats": [
        {
          "value": "24/7",
          "label": "awaryjne wsparcie, zależnie od dostępności"
        },
        {
          "value": "WhatsApp",
          "label": "pisemne wsparcie — cena ustalona przed rozpoczęciem pracy"
        }
      ]
    },
    "reviews": {
      "title": "Opinie Google",
      "body": "Opinie Google wkrótce.",
      "note": "Nasz Profil Firmy w Google jest w trakcie weryfikacji. Gdy będzie aktywny, będzie można tutaj czytać i zostawiać opinie.",
      "button": "Zostaw opinię w Google"
    },
    "faq": {
      "title": "Często zadawane pytania",
      "items": [
        {
          "id": "written",
          "q": "Czy zapewniacie pisemne wsparcie przez WhatsApp?",
          "a": "Tak. Możesz opisać swoją sytuację, wysłać lokalizację i udostępnić zdjęcia przez WhatsApp."
        },
        {
          "id": "night",
          "q": "Czy pracujecie w nocy?",
          "a": "Zapewniamy wsparcie awaryjne 24/7, zależnie od dostępności w Twojej okolicy."
        },
        {
          "id": "request",
          "q": "Jak poprosić o pomoc?",
          "a": "Napisz do nas na WhatsApp, podając swoją lokalizację i opis problemu."
        },
        {
          "id": "photo",
          "q": "Czy muszę wysłać zdjęcie?",
          "a": "Zdjęcie może pomóc nam zrozumieć sytuację, ale nie zawsze jest wymagane."
        },
        {
          "id": "price",
          "q": "Czy poznam cenę przed rozpoczęciem pracy?",
          "a": "Wyjaśniamy cenę przed rozpoczęciem pracy. Akceptujesz ją, zanim zaczniemy."
        },
        {
          "id": "car",
          "q": "Czy możecie otworzyć zatrzaśnięty samochód?",
          "a": "Zapewniamy pomoc przy zatrzaśnięciu samochodu tam, gdzie jest dostępna. Przed otwarciem pojazdu możemy poprosić o dowód własności lub zgodę."
        },
        {
          "id": "business",
          "q": "Czy obsługujecie firmy?",
          "a": "Tak. Pomagamy przy zatrzaśnięciach w biurach, sklepach i firmach tam, gdzie jest to dostępne."
        }
      ]
    },
    "contact": {
      "title": "Wyślij zgłoszenie na piśmie",
      "sub": "Wypełnij to, a otworzymy WhatsApp z gotowymi do wysłania Twoimi danymi. Możesz dołączyć zdjęcia na czacie.",
      "name": "Imię",
      "phone": "Numer WhatsApp",
      "location": "Obszar lub kod pocztowy",
      "issue": "W czym potrzebujesz pomocy?",
      "issueOptions": [
        "Zatrzasnąłem się poza domem",
        "Zatrzasnąłem się poza firmą",
        "Zatrzasnąłem się poza samochodem",
        "Wymiana lub naprawa zamka",
        "Naprawa po włamaniu",
        "Zgubione klucze",
        "Inne"
      ],
      "message": "Opisz, co się stało",
      "photoHint": "Masz zdjęcie? Dołącz je na czacie WhatsApp po wysłaniu — pomoże nam to zrozumieć sytuację.",
      "submit": "Wyślij zgłoszenie przez WhatsApp",
      "sending": "Przygotowywanie…",
      "successTitle": "Zgłoszenie gotowe",
      "successBody": "WhatsApp otwiera się z Twoimi danymi. Jeśli to pomocne, dołącz zdjęcia na czacie.",
      "errorTitle": "Coś poszło nie tak",
      "errorBody": "Spróbuj ponownie lub napisz do nas bezpośrednio na WhatsApp.",
      "whatsappCta": "Napisz do nas na WhatsApp",
      "emailCta": "Wyślij nam e-mail",
      "photosCta": "Wyślij zdjęcia na WhatsApp",
      "writingCta": "Skontaktuj się z nami na piśmie",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "waPhotoMessage": "Hi! I'm sending photos of my door, lock or vehicle. My location is: ",
      "waLabels": {
        "intro": "Cześć! Potrzebuję ślusarza.",
        "name": "Imię",
        "phone": "WhatsApp",
        "location": "Lokalizacja",
        "issue": "Potrzebna pomoc",
        "message": "Co się stało"
      },
      "validation": {
        "name": "Wpisz swoje imię (min. 2 znaki)",
        "phone": "Wpisz prawidłowy numer WhatsApp",
        "message": "Opisz, co się stało (min. 5 znaków)"
      }
    },
    "footer": {
      "tagline": "Awaryjne wsparcie ślusarskie 24/7 w Edinburgh, Glasgow i okolicach. Pisemne wsparcie przez WhatsApp.",
      "contactTitle": "Kontakt",
      "coverageTitle": "Obszary działania",
      "aboutTitle": "O nas",
      "legal": "Niezależna jednoosobowa usługa ślusarska.",
      "legal2": "UNLockSmiths to niezależna, jednoosobowa usługa ślusarska działająca w Edinburgh i okolicach.",
      "rights": "Wszelkie prawa zastrzeżone.",
      "website": "Strona internetowa"
    },
    "social": {
      "title": "Obserwuj nas i napisz do nas",
      "sub": "Jesteśmy dostępni 24 godziny na dobę, 7 dni w tygodniu w zakresie awaryjnych usług ślusarskich w Edinburgh, Glasgow i okolicach."
    },
    "chat": {
      "title": "Asystent UNLockSmiths",
      "subtitle": "Online — odpowiada 24/7",
      "welcome": "Cześć! Jestem asystentem UNLockSmiths. Zapytaj mnie o cokolwiek: usługi, obszary, dostępność…",
      "suggestions": [
        "Czy jesteście teraz dostępni?",
        "Czy obsługujecie moją okolicę?",
        "Jak poprosić o pomoc?"
      ],
      "placeholder": "Wpisz swoje pytanie…",
      "error": "Przepraszamy, coś poszło nie tak. Spróbuj ponownie lub napisz do nas na WhatsApp.",
      "open": "Porozmawiaj z naszym asystentem"
    },
    "float": {
      "label": "Napisz do nas na WhatsApp",
      "waMessage": "Hi! I need a locksmith. My situation: "
    },
    "video": {
      "title": "Zatrzaśnięte drzwi? Pomoc jest o jedną wiadomość stąd.",
      "sub": "Zobacz, jak to działa w 20 sekund: napisz na WhatsApp, wyślij lokalizację i zdjęcie, a cenę uzgodnimy na piśmie przed rozpoczęciem.",
      "unmute": "Włącz dźwięk",
      "mute": "Wycisz",
      "aria": "Film promocyjny UNLockSmiths: awaryjny ślusarz 24/7 w Edynburgu — napisz na WhatsApp"
    },
    "aboutMe": {
      "label": "O mnie",
      "title": "Poznaj swojego ślusarza",
      "quote": "Cześć, jestem Alfonso, Twój lokalny ślusarz w Edynburgu. Cenę uzgadniam z Tobą na piśmie przed rozpoczęciem pracy, więc nie ma niespodzianek."
    }
  },
  it: {
    "meta": {
      "title": "Fabbro d'emergenza 24/7 Edinburgh | UNLockSmiths",
      "description": "UNLockSmiths offre assistenza scritta 24/7 su WhatsApp per lockout di casa, attività e auto a Edinburgh, Glasgow e zone limitrofe. Inviaci un messaggio con la tua posizione e delle foto."
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "Disponibile 24/7 — assistenza scritta su WhatsApp",
      "line1": "Chiuso fuori?",
      "line2": "Scrivi a UNLockSmiths",
      "line3": "ora.",
      "sub1": "Assistenza fabbro d'emergenza 24/7 a Edinburgh, Glasgow e zone limitrofe.",
      "sub2": "Inviaci la tua posizione e spiega cosa è successo. Puoi anche inviare foto della porta, della serratura o del veicolo. Rispondiamo per iscritto su WhatsApp.",
      "whatsapp": "Scrivici su WhatsApp",
      "quote": "Ottieni un preventivo scritto",
      "waMessage": "Ciao! Ho bisogno di un fabbro. La mia situazione: ",
      "trust": [
        "Disponibile 24/7",
        "Assistenza scritta su WhatsApp",
        "Prezzo concordato prima dell'inizio dei lavori"
      ],
      "priceLine": "Invia una foto e ricevi un prezzo chiaro per iscritto prima di iniziare qualsiasi lavoro."
    },
    "marquee": [
      "FABBRO D'EMERGENZA 24/7 EDINBURGH",
      "CASA · ATTIVITÀ · AUTO CHIUSA",
      "ASSISTENZA SCRITTA SU WHATSAPP",
      "EDINBURGH · GLASGOW · ZONE LIMITROFE",
      "PREZZO CONCORDATO PRIMA DELL'INIZIO DEI LAVORI",
      "SOSTITUZIONE E RIPARAZIONE SERRATURE",
      "INDIPENDENTE E LOCALE"
    ],
    "services": {
      "title": "I nostri servizi di fabbro",
      "sub": "Assistenza fabbro d'emergenza per case, attività e veicoli a Edinburgh, Glasgow e zone limitrofe — organizzata per iscritto su WhatsApp.",
      "categories": [
        {
          "id": "home",
          "title": "Fabbro per la casa",
          "desc": "Chiuso fuori casa a Edinburgh? Apertura porte d'emergenza, sostituzione e riparazione serrature per la tua abitazione.",
          "items": [
            "Apertura porte di casa",
            "Apertura porte d'emergenza",
            "Sostituzione serrature",
            "Riparazione serrature",
            "Assistenza per chiavi smarrite",
            "Riparazioni dopo effrazione",
            "Installazione di nuove serrature"
          ]
        },
        {
          "id": "business",
          "title": "Fabbro per attività",
          "desc": "Chiuso fuori dalla tua attività o sostituzione di serrature commerciali — accesso d'emergenza per uffici e negozi.",
          "items": [
            "Apertura uffici",
            "Apertura negozi e attività",
            "Sostituzione serrature commerciali",
            "Riparazione serrature per attività",
            "Accesso d'emergenza per uffici e negozi"
          ]
        },
        {
          "id": "auto",
          "title": "Fabbro auto",
          "desc": "Auto chiusa a Edinburgh o Glasgow? Apertura del veicolo quando le chiavi sono rimaste dentro.",
          "items": [
            "Apertura auto",
            "Apertura veicolo",
            "Chiavi rimaste chiuse nel veicolo"
          ]
        }
      ],
      "book": "Scrivici per questo servizio"
    },
    "how": {
      "title": "Come funziona",
      "sub": "Tre semplici passaggi — tutto per iscritto.",
      "steps": [
        {
          "title": "Scrivici su WhatsApp",
          "desc": "Dicci cosa è successo e dove ti trovi."
        },
        {
          "title": "Invia foto se utili",
          "desc": "Invia una foto della porta, della serratura o del veicolo se è sicuro farlo."
        },
        {
          "title": "Concorda il prezzo per iscritto",
          "desc": "Nessun lavoro inizia finché non accetti il prezzo."
        }
      ]
    },
    "trust": {
      "title": "Prezzi chiari. Comunicazione scritta. Nessuna pressione.",
      "body": "Ti spieghiamo la situazione per iscritto prima dell'inizio dei lavori. Accetti il prezzo prima che iniziamo. Se non sei sicuro del servizio di cui hai bisogno, scrivici e ti guideremo.",
      "cta": "Contattaci per iscritto"
    },
    "coverage": {
      "title": "Zone servite",
      "sub": "Operiamo principalmente a Edinburgh, con disponibilità a Glasgow e nelle città vicine. Inviaci la tua posizione e confermeremo se possiamo aiutarti.",
      "main": "Area di servizio principale",
      "additional": "Disponibile anche a",
      "cta": "Non sei sicuro che copriamo la tua zona? Inviaci la tua posizione.",
      "ctaBtn": "Scrivici su WhatsApp"
    },
    "about": {
      "title": "Un fabbro locale indipendente",
      "p1": "UNLockSmiths è un servizio di fabbro indipendente e autonomo che opera a Edinburgh e nelle zone limitrofe.",
      "p2": "Lavoriamo per iscritto: spieghi il problema, invii la tua posizione e delle foto, e confermiamo il prezzo prima che inizi qualsiasi lavoro. Apertura di casa, attività e auto, sostituzione e riparazione serrature — di giorno o di notte, secondo disponibilità.",
      "overlay": "Chiavi chiuse in auto? Scrivici su WhatsApp.",
      "stats": [
        {
          "value": "24/7",
          "label": "assistenza d'emergenza, secondo disponibilità"
        },
        {
          "value": "WhatsApp",
          "label": "assistenza scritta — prezzo concordato prima dell'inizio dei lavori"
        }
      ]
    },
    "reviews": {
      "title": "Recensioni Google",
      "body": "Recensioni Google in arrivo.",
      "note": "Il nostro profilo Google Business è in fase di verifica. Una volta attivo, potrai leggere e lasciare recensioni qui.",
      "button": "Lasciaci una recensione su Google"
    },
    "faq": {
      "title": "Domande frequenti",
      "items": [
        {
          "id": "written",
          "q": "Fornite assistenza scritta su WhatsApp?",
          "a": "Sì. Puoi spiegare la tua situazione, inviare la tua posizione e condividere foto tramite WhatsApp."
        },
        {
          "id": "night",
          "q": "Lavorate di notte?",
          "a": "Forniamo assistenza d'emergenza 24/7, secondo disponibilità nella tua zona."
        },
        {
          "id": "request",
          "q": "Come posso richiedere aiuto?",
          "a": "Scrivici su WhatsApp con la tua posizione e una descrizione del problema."
        },
        {
          "id": "photo",
          "q": "Devo inviare una foto?",
          "a": "Una foto può aiutarci a capire la situazione, ma non è sempre necessaria."
        },
        {
          "id": "price",
          "q": "Conoscerò il prezzo prima dell'inizio dei lavori?",
          "a": "Ti spieghiamo il prezzo prima dell'inizio dei lavori. Accetti prima che iniziamo."
        },
        {
          "id": "car",
          "q": "Potete aprire un'auto chiusa?",
          "a": "Forniamo assistenza per auto chiuse dove disponibile. Potremmo chiedere una prova di proprietà o un'autorizzazione prima di aprire un veicolo."
        },
        {
          "id": "business",
          "q": "Servite anche le attività?",
          "a": "Sì. Aiutiamo con aperture di uffici, negozi e attività dove disponibile."
        }
      ]
    },
    "contact": {
      "title": "Invia la tua richiesta per iscritto",
      "sub": "Compila questo modulo e apriremo WhatsApp con i tuoi dati pronti da inviare. Puoi allegare foto nella chat.",
      "name": "Nome",
      "phone": "Numero WhatsApp",
      "location": "Zona o codice postale",
      "issue": "Per cosa hai bisogno di aiuto?",
      "issueOptions": [
        "Chiuso fuori casa",
        "Chiuso fuori dalla mia attività",
        "Chiuso fuori dalla mia auto",
        "Sostituzione o riparazione serratura",
        "Riparazione dopo effrazione",
        "Chiavi smarrite",
        "Altro"
      ],
      "message": "Descrivi cosa è successo",
      "photoHint": "Hai una foto? Allegala nella chat di WhatsApp dopo l'invio — ci aiuta a capire la situazione.",
      "submit": "Invia richiesta tramite WhatsApp",
      "sending": "Preparazione in corso…",
      "successTitle": "Richiesta pronta",
      "successBody": "WhatsApp si sta aprendo con i tuoi dati. Allega foto nella chat se utili.",
      "errorTitle": "Qualcosa è andato storto",
      "errorBody": "Riprova oppure scrivici direttamente su WhatsApp.",
      "whatsappCta": "Scrivici su WhatsApp",
      "emailCta": "Inviaci un'email",
      "photosCta": "Invia foto su WhatsApp",
      "writingCta": "Contattaci per iscritto",
      "waMessage": "Ciao! Ho bisogno di un fabbro. La mia situazione: ",
      "waPhotoMessage": "Ciao! Sto inviando foto della mia porta, serratura o veicolo. La mia posizione è: ",
      "waLabels": {
        "intro": "Ciao! Ho bisogno di un fabbro.",
        "name": "Nome",
        "phone": "WhatsApp",
        "location": "Posizione",
        "issue": "Aiuto richiesto",
        "message": "Cosa è successo"
      },
      "validation": {
        "name": "Inserisci il tuo nome (min. 2 caratteri)",
        "phone": "Inserisci un numero WhatsApp valido",
        "message": "Descrivi cosa è successo (min. 5 caratteri)"
      }
    },
    "footer": {
      "tagline": "Assistenza fabbro d'emergenza 24/7 a Edinburgh, Glasgow e zone limitrofe. Assistenza scritta su WhatsApp.",
      "contactTitle": "Contatti",
      "coverageTitle": "Zone servite",
      "aboutTitle": "Chi siamo",
      "legal": "Servizio di fabbro indipendente come ditta individuale.",
      "legal2": "UNLockSmiths è un servizio di fabbro indipendente e autonomo che opera a Edinburgh e nelle zone limitrofe.",
      "rights": "Tutti i diritti riservati.",
      "website": "Sito web"
    },
    "social": {
      "title": "Seguici e scrivici",
      "sub": "Siamo disponibili 24 ore su 24, 7 giorni su 7 per servizi di fabbro d'emergenza a Edinburgh, Glasgow e zone limitrofe."
    },
    "chat": {
      "title": "Assistente UNLockSmiths",
      "subtitle": "Online — risponde 24/7",
      "welcome": "Ciao! Sono l'assistente di UNLockSmiths. Chiedimi qualsiasi cosa: servizi, zone, disponibilità…",
      "suggestions": [
        "Siete disponibili adesso?",
        "Coprite la mia zona?",
        "Come posso richiedere aiuto?"
      ],
      "placeholder": "Scrivi la tua domanda…",
      "error": "Ci dispiace, qualcosa è andato storto. Riprova oppure scrivici su WhatsApp.",
      "open": "Chatta con il nostro assistente"
    },
    "float": {
      "label": "Scrivici su WhatsApp",
      "waMessage": "Ciao! Ho bisogno di un fabbro. La mia situazione: "
    },
    "video": {
      "title": "Chiuso fuori? L’aiuto è a un messaggio di distanza.",
      "sub": "Guarda come funziona in 20 secondi: scrivici su WhatsApp, invia posizione e foto e concorda il prezzo per iscritto prima di iniziare.",
      "unmute": "Attiva audio",
      "mute": "Silenzia",
      "aria": "Video promozionale UNLockSmiths: fabbro di emergenza 24/7 a Edimburgo — scrivici su WhatsApp"
    },
    "aboutMe": {
      "label": "Chi sono",
      "title": "Il tuo fabbro",
      "quote": "Ciao, sono Alfonso, il tuo fabbro locale a Edimburgo. Concordo il prezzo con te per iscritto prima di iniziare, così non ci sono sorprese."
    }
  },
  fr: {
    "meta": {
      "title": "Serrurier d'urgence 24/7 Edinburgh | UNLockSmiths",
      "description": "UNLockSmiths propose une assistance écrite 24/7 sur WhatsApp pour les portes claquées ou verrouillées de maison, d'entreprise et de voiture à Edinburgh, Glasgow et dans les environs. Envoyez-nous votre localisation et des photos."
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "Disponible 24/7 — assistance écrite sur WhatsApp",
      "line1": "Porte claquée ou verrouillée ?",
      "line2": "Écrivez à UNLockSmiths",
      "line3": "maintenant.",
      "sub1": "Assistance serrurier d'urgence 24/7 à Edinburgh, Glasgow et dans les environs.",
      "sub2": "Envoyez-nous votre localisation et expliquez ce qui s'est passé. Vous pouvez aussi envoyer des photos de la porte, de la serrure ou du véhicule. Nous répondons par écrit sur WhatsApp.",
      "whatsapp": "Écrivez-nous sur WhatsApp",
      "quote": "Obtenir un devis écrit",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "trust": [
        "Disponible 24/7",
        "Assistance écrite sur WhatsApp",
        "Prix convenu avant le début des travaux"
      ],
      "priceLine": "Envoyez une photo et recevez un prix clair par écrit avant tout travail."
    },
    "marquee": [
      "SERRURIER D'URGENCE 24/7 EDINBURGH",
      "MAISON · ENTREPRISE · VOITURE",
      "ASSISTANCE ÉCRITE SUR WHATSAPP",
      "EDINBURGH · GLASGOW · ENVIRONS",
      "PRIX CONVENU AVANT LE DÉBUT DES TRAVAUX",
      "CHANGEMENT ET RÉPARATION DE SERRURES",
      "INDÉPENDANT & LOCAL"
    ],
    "services": {
      "title": "Nos services de serrurerie",
      "sub": "Aide serrurier d'urgence pour les maisons, les entreprises et les véhicules à Edinburgh, Glasgow et dans les environs — organisée par écrit sur WhatsApp.",
      "categories": [
        {
          "id": "home",
          "title": "Serrurerie résidentielle",
          "desc": "Porte claquée ou verrouillée à Edinburgh ? Ouverture de porte en urgence, changement et réparation de serrures pour votre domicile.",
          "items": [
            "Portes de maison claquées ou verrouillées",
            "Ouverture de porte en urgence",
            "Changement de serrures",
            "Réparation de serrures",
            "Assistance en cas de perte de clés",
            "Réparations après effraction",
            "Installation de nouvelles serrures"
          ]
        },
        {
          "id": "business",
          "title": "Serrurerie pour entreprises",
          "desc": "Accès bloqué en entreprise ou changement de serrure commerciale — accès d'urgence pour bureaux et commerces.",
          "items": [
            "Accès bloqué aux bureaux",
            "Accès bloqué aux commerces et entreprises",
            "Changement de serrures commerciales",
            "Réparation de serrures pour entreprises",
            "Accès d'urgence pour bureaux et commerces"
          ]
        },
        {
          "id": "auto",
          "title": "Serrurerie automobile",
          "desc": "Voiture verrouillée à Edinburgh ou Glasgow ? Ouverture de véhicule lorsque vos clés sont restées à l'intérieur.",
          "items": [
            "Voitures verrouillées",
            "Ouverture de véhicule",
            "Clés restées à l'intérieur du véhicule"
          ]
        }
      ],
      "book": "Écrivez-nous à ce sujet"
    },
    "how": {
      "title": "Comment ça marche",
      "sub": "Trois étapes simples — tout se fait par écrit.",
      "steps": [
        {
          "title": "Écrivez-nous sur WhatsApp",
          "desc": "Dites-nous ce qui s'est passé et où vous vous trouvez."
        },
        {
          "title": "Envoyez des photos si utile",
          "desc": "Envoyez une photo de la porte, de la serrure ou du véhicule si vous pouvez le faire en toute sécurité."
        },
        {
          "title": "Convenez du prix par écrit",
          "desc": "Aucun travail ne commence tant que vous n'avez pas accepté le prix."
        }
      ]
    },
    "trust": {
      "title": "Prix clairs. Communication écrite. Sans pression.",
      "body": "Nous expliquons la situation par écrit avant le début des travaux. Vous acceptez le prix avant que nous commencions. Si vous ne savez pas quel service il vous faut, écrivez-nous et nous vous guiderons.",
      "cta": "Contactez-nous par écrit"
    },
    "coverage": {
      "title": "Zones d'intervention",
      "sub": "Nous intervenons principalement à Edinburgh, avec une disponibilité à Glasgow et dans les villes voisines. Envoyez-nous votre localisation et nous vous confirmerons si nous pouvons vous aider.",
      "main": "Zone d'intervention principale",
      "additional": "Également disponible à",
      "cta": "Vous ne savez pas si nous intervenons dans votre secteur ? Envoyez-nous votre localisation.",
      "ctaBtn": "Écrivez-nous sur WhatsApp"
    },
    "about": {
      "title": "Un serrurier local indépendant",
      "p1": "UNLockSmiths est un service de serrurerie indépendant exploité en nom propre, au service de Edinburgh et des environs.",
      "p2": "Nous travaillons par écrit : vous expliquez le problème, envoyez votre localisation et des photos, et nous confirmons le prix avant le début de toute intervention. Portes de maison, d'entreprise et de voiture claquées ou verrouillées, changement et réparation de serrures — de jour comme de nuit, sous réserve de disponibilité.",
      "overlay": "Clés enfermées dans votre voiture ? Écrivez-nous sur WhatsApp.",
      "stats": [
        {
          "value": "24/7",
          "label": "assistance d'urgence, sous réserve de disponibilité"
        },
        {
          "value": "WhatsApp",
          "label": "assistance écrite — prix convenu avant le début des travaux"
        }
      ]
    },
    "reviews": {
      "title": "Avis Google",
      "body": "Les avis Google arrivent bientôt.",
      "note": "Notre profil Google Business est en cours de vérification. Une fois en ligne, vous pourrez lire et laisser des avis ici.",
      "button": "Laissez-nous un avis Google"
    },
    "faq": {
      "title": "Questions fréquentes",
      "items": [
        {
          "id": "written",
          "q": "Proposez-vous une assistance écrite sur WhatsApp ?",
          "a": "Oui. Vous pouvez expliquer votre situation, envoyer votre localisation et partager des photos par WhatsApp."
        },
        {
          "id": "night",
          "q": "Travaillez-vous la nuit ?",
          "a": "Nous proposons une assistance d'urgence 24/7, sous réserve de disponibilité dans votre secteur."
        },
        {
          "id": "request",
          "q": "Comment demander de l'aide ?",
          "a": "Écrivez-nous sur WhatsApp avec votre localisation et une description du problème."
        },
        {
          "id": "photo",
          "q": "Dois-je envoyer une photo ?",
          "a": "Une photo peut nous aider à comprendre la situation, mais elle n'est pas toujours nécessaire."
        },
        {
          "id": "price",
          "q": "Connaîtrai-je le prix avant le début des travaux ?",
          "a": "Nous expliquons le prix avant le début des travaux. Vous donnez votre accord avant que nous commencions."
        },
        {
          "id": "car",
          "q": "Pouvez-vous ouvrir une voiture verrouillée ?",
          "a": "Nous proposons une assistance pour les voitures verrouillées lorsque cela est possible. Nous pouvons demander une preuve de propriété ou une autorisation avant d'ouvrir un véhicule."
        },
        {
          "id": "business",
          "q": "Intervenez-vous pour les entreprises ?",
          "a": "Oui. Nous aidons pour les accès bloqués aux bureaux, commerces et entreprises lorsque cela est possible."
        }
      ]
    },
    "contact": {
      "title": "Envoyez votre demande par écrit",
      "sub": "Remplissez ce formulaire et nous ouvrirons WhatsApp avec vos informations prêtes à envoyer. Vous pouvez joindre des photos dans la conversation.",
      "name": "Nom",
      "phone": "Numéro WhatsApp",
      "location": "Secteur ou code postal",
      "issue": "Pour quoi avez-vous besoin d'aide ?",
      "issueOptions": [
        "Porte de mon domicile claquée ou verrouillée",
        "Accès à mon entreprise bloqué",
        "Voiture verrouillée",
        "Changement ou réparation de serrure",
        "Réparation après effraction",
        "Clés perdues",
        "Autre"
      ],
      "message": "Décrivez ce qui s'est passé",
      "photoHint": "Vous avez une photo ? Joignez-la dans la conversation WhatsApp après l'envoi — cela nous aide à comprendre la situation.",
      "submit": "Envoyer la demande par WhatsApp",
      "sending": "Préparation…",
      "successTitle": "Demande prête",
      "successBody": "WhatsApp s'ouvre avec vos informations. Joignez des photos dans la conversation si cela peut aider.",
      "errorTitle": "Un problème est survenu",
      "errorBody": "Veuillez réessayer ou nous écrire directement sur WhatsApp.",
      "whatsappCta": "Écrivez-nous sur WhatsApp",
      "emailCta": "Envoyez-nous un e-mail",
      "photosCta": "Envoyer des photos sur WhatsApp",
      "writingCta": "Contactez-nous par écrit",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "waPhotoMessage": "Hi! I'm sending photos of my door, lock or vehicle. My location is: ",
      "waLabels": {
        "intro": "Bonjour ! J'ai besoin d'un serrurier.",
        "name": "Nom",
        "phone": "WhatsApp",
        "location": "Localisation",
        "issue": "Aide nécessaire",
        "message": "Ce qui s'est passé"
      },
      "validation": {
        "name": "Veuillez saisir votre nom (min. 2 caractères)",
        "phone": "Veuillez saisir un numéro WhatsApp valide",
        "message": "Veuillez décrire ce qui s'est passé (min. 5 caractères)"
      }
    },
    "footer": {
      "tagline": "Assistance serrurier d'urgence 24/7 à Edinburgh, Glasgow et dans les environs. Assistance écrite sur WhatsApp.",
      "contactTitle": "Contact",
      "coverageTitle": "Zones d'intervention",
      "aboutTitle": "À propos",
      "legal": "Service de serrurerie indépendant exploité en nom propre.",
      "legal2": "UNLockSmiths est un service de serrurerie indépendant exploité en nom propre, au service de Edinburgh et des environs.",
      "rights": "Tous droits réservés.",
      "website": "Site web"
    },
    "social": {
      "title": "Suivez-nous et écrivez-nous",
      "sub": "Nous sommes disponibles 24 heures sur 24, 7 jours sur 7 pour les services de serrurerie d'urgence à Edinburgh, Glasgow et dans les environs."
    },
    "chat": {
      "title": "Assistant UNLockSmiths",
      "subtitle": "En ligne — réponses 24/7",
      "welcome": "Bonjour ! Je suis l'assistant UNLockSmiths. Posez-moi toutes vos questions : services, zones, disponibilité…",
      "suggestions": [
        "Êtes-vous disponible maintenant ?",
        "Intervenez-vous dans mon secteur ?",
        "Comment demander de l'aide ?"
      ],
      "placeholder": "Tapez votre question…",
      "error": "Désolé, un problème est survenu. Réessayez ou écrivez-nous sur WhatsApp.",
      "open": "Discuter avec notre assistant"
    },
    "float": {
      "label": "Écrivez-nous sur WhatsApp",
      "waMessage": "Hi! I need a locksmith. My situation: "
    },
    "video": {
      "title": "Enfermé dehors ? L’aide est à un message.",
      "sub": "Découvrez comment ça marche en 20 secondes : écrivez-nous sur WhatsApp, envoyez votre position et une photo, puis validez le prix par écrit avant de commencer.",
      "unmute": "Activer le son",
      "mute": "Couper le son",
      "aria": "Vidéo promo UNLockSmiths : serrurier d’urgence 24h/24 à Édimbourg — écrivez-nous sur WhatsApp"
    },
    "aboutMe": {
      "label": "À propos de moi",
      "title": "Votre serrurier",
      "quote": "Bonjour, je suis Alfonso, votre serrurier local à Édimbourg. Je conviens du prix avec vous par écrit avant de commencer, pour éviter toute surprise."
    }
  },
  pt: {
    "meta": {
      "title": "Serralheiro de Emergência 24/7 Edinburgh | UNLockSmiths",
      "description": "A UNLockSmiths disponibiliza apoio escrito 24/7 por WhatsApp para situações de portas trancadas em casa, empresas e carros em Edinburgh, Glasgow e áreas circundantes. Envie-nos a sua localização e fotografias."
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "Disponível 24/7 — apoio escrito por WhatsApp",
      "line1": "Ficou trancado de fora?",
      "line2": "Envie mensagem à UNLockSmiths",
      "line3": "agora.",
      "sub1": "Apoio de serralheiro de emergência 24/7 em Edinburgh, Glasgow e áreas circundantes.",
      "sub2": "Envie-nos a sua localização e explique o que aconteceu. Também pode enviar fotografias da porta, fechadura ou veículo. Respondemos por escrito no WhatsApp.",
      "whatsapp": "Envie-nos mensagem no WhatsApp",
      "quote": "Obter orçamento por escrito",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "trust": [
        "Disponível 24/7",
        "Apoio escrito por WhatsApp",
        "Preço acordado antes do início do trabalho"
      ],
      "priceLine": "Envie uma foto e receba um preço claro por escrito antes de qualquer trabalho."
    },
    "marquee": [
      "SERRALHEIRO DE EMERGÊNCIA 24/7 EDINBURGH",
      "CASA · EMPRESA · CARROS TRANCADOS",
      "APOIO ESCRITO POR WHATSAPP",
      "EDINBURGH · GLASGOW · ÁREAS CIRCUNDANTES",
      "PREÇO ACORDADO ANTES DO INÍCIO DO TRABALHO",
      "MUDANÇA E REPARAÇÃO DE FECHADURAS",
      "INDEPENDENTE E LOCAL"
    ],
    "services": {
      "title": "Os nossos serviços de serralharia",
      "sub": "Ajuda de serralharia de emergência para casas, empresas e veículos em Edinburgh, Glasgow e áreas circundantes — tratado por escrito no WhatsApp.",
      "categories": [
        {
          "id": "home",
          "title": "Serralheiro para Casa",
          "desc": "Ficou trancado fora de casa em Edinburgh? Abertura urgente de portas, mudança de fechaduras e reparações para a sua casa.",
          "items": [
            "Portas de casa trancadas",
            "Abertura urgente de portas",
            "Mudança de fechaduras",
            "Reparação de fechaduras",
            "Ajuda com perda de chaves",
            "Reparações após assalto",
            "Instalação de novas fechaduras"
          ]
        },
        {
          "id": "business",
          "title": "Serralheiro para Empresas",
          "desc": "Porta de empresa trancada ou mudança de fechadura comercial — acesso de emergência para escritórios e lojas.",
          "items": [
            "Portas de escritórios trancadas",
            "Portas de lojas e empresas trancadas",
            "Mudança de fechaduras comerciais",
            "Reparação de fechaduras para empresas",
            "Acesso de emergência para escritórios e lojas"
          ]
        },
        {
          "id": "auto",
          "title": "Serralheiro Auto",
          "desc": "Ficou trancado fora do carro em Edinburgh ou Glasgow? Abertura de veículo quando as chaves ficam lá dentro.",
          "items": [
            "Carros trancados",
            "Abertura de veículo",
            "Chaves trancadas dentro do veículo"
          ]
        }
      ],
      "book": "Envie-nos mensagem sobre isto"
    },
    "how": {
      "title": "Como funciona",
      "sub": "Três passos simples — tudo por escrito.",
      "steps": [
        {
          "title": "Envie-nos mensagem no WhatsApp",
          "desc": "Diga-nos o que aconteceu e onde está."
        },
        {
          "title": "Envie fotografias se ajudar",
          "desc": "Envie uma fotografia da porta, fechadura ou veículo, se for seguro fazê-lo."
        },
        {
          "title": "Acorde o preço por escrito",
          "desc": "Nenhum trabalho começa até concordar com o preço."
        }
      ]
    },
    "trust": {
      "title": "Preços claros. Comunicação por escrito. Sem pressão.",
      "body": "Explicamos a situação por escrito antes do início do trabalho. Concorda com o preço antes de começarmos. Se não tiver a certeza de que serviço precisa, envie-nos mensagem e nós orientamo-lo.",
      "cta": "Contacte-nos por escrito"
    },
    "coverage": {
      "title": "Áreas de serviço",
      "sub": "Servimos principalmente Edinburgh, com disponibilidade em Glasgow e localidades circundantes. Envie-nos a sua localização e confirmaremos se podemos ajudar.",
      "main": "Área principal de serviço",
      "additional": "Também disponível em",
      "cta": "Não tem a certeza se cobrimos a sua zona? Envie-nos a sua localização.",
      "ctaBtn": "Envie-nos mensagem no WhatsApp"
    },
    "about": {
      "title": "Um serralheiro local independente",
      "p1": "A UNLockSmiths é um serviço de serralharia independente por conta própria que serve Edinburgh e áreas circundantes.",
      "p2": "Trabalhamos por escrito: explica o problema, envia a sua localização e fotografias, e confirmamos o preço antes de qualquer trabalho começar. Portas de casas, empresas e carros trancadas, mudança de fechaduras e reparações — de dia ou de noite, sujeito a disponibilidade.",
      "overlay": "Chaves trancadas dentro do carro? Envie-nos mensagem no WhatsApp.",
      "stats": [
        {
          "value": "24/7",
          "label": "apoio de emergência, sujeito a disponibilidade"
        },
        {
          "value": "WhatsApp",
          "label": "apoio por escrito — preço acordado antes do início do trabalho"
        }
      ]
    },
    "reviews": {
      "title": "Avaliações Google",
      "body": "Avaliações Google em breve.",
      "note": "O nosso Perfil de Empresa Google está em processo de verificação. Quando estiver ativo, poderá ler e deixar avaliações aqui.",
      "button": "Deixe-nos uma avaliação no Google"
    },
    "faq": {
      "title": "Perguntas frequentes",
      "items": [
        {
          "id": "written",
          "q": "Disponibilizam apoio escrito por WhatsApp?",
          "a": "Sim. Pode explicar a sua situação, enviar a sua localização e partilhar fotografias por WhatsApp."
        },
        {
          "id": "night",
          "q": "Trabalham durante a noite?",
          "a": "Disponibilizamos apoio de emergência 24/7, sujeito a disponibilidade na sua zona."
        },
        {
          "id": "request",
          "q": "Como posso pedir ajuda?",
          "a": "Envie-nos mensagem no WhatsApp com a sua localização e uma descrição do problema."
        },
        {
          "id": "photo",
          "q": "Preciso de enviar uma fotografia?",
          "a": "Uma fotografia pode ajudar-nos a compreender a situação, mas nem sempre é necessária."
        },
        {
          "id": "price",
          "q": "Vou saber o preço antes do início do trabalho?",
          "a": "Explicamos o preço antes do início do trabalho. Concorda antes de começarmos."
        },
        {
          "id": "car",
          "q": "Conseguem abrir um carro trancado?",
          "a": "Prestamos assistência para carros trancados quando disponível. Poderemos pedir prova de propriedade ou autorização antes de abrir um veículo."
        },
        {
          "id": "business",
          "q": "Atendem empresas?",
          "a": "Sim. Ajudamos com portas de escritórios, lojas e empresas trancadas, quando disponível."
        }
      ]
    },
    "contact": {
      "title": "Envie o seu pedido por escrito",
      "sub": "Preencha isto e abriremos o WhatsApp com os seus dados prontos a enviar. Pode anexar fotografias na conversa.",
      "name": "Nome",
      "phone": "Número de WhatsApp",
      "location": "Zona ou código postal",
      "issue": "Com o que precisa de ajuda?",
      "issueOptions": [
        "Fiquei trancado fora de casa",
        "Fiquei trancado fora da minha empresa",
        "Fiquei trancado fora do meu carro",
        "Mudança ou reparação de fechadura",
        "Reparação após assalto",
        "Perda de chaves",
        "Outro"
      ],
      "message": "Descreva o que aconteceu",
      "photoHint": "Tem uma fotografia? Anexe-a na conversa do WhatsApp depois de enviar — ajuda-nos a compreender a situação.",
      "submit": "Enviar pedido por WhatsApp",
      "sending": "A preparar…",
      "successTitle": "Pedido pronto",
      "successBody": "O WhatsApp está a abrir com os seus dados. Anexe fotografias na conversa se for útil.",
      "errorTitle": "Algo correu mal",
      "errorBody": "Tente novamente ou envie-nos mensagem diretamente no WhatsApp.",
      "whatsappCta": "Envie-nos mensagem no WhatsApp",
      "emailCta": "Envie-nos um e-mail",
      "photosCta": "Envie fotografias no WhatsApp",
      "writingCta": "Contacte-nos por escrito",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "waPhotoMessage": "Hi! I'm sending photos of my door, lock or vehicle. My location is: ",
      "waLabels": {
        "intro": "Hi! I need a locksmith.",
        "name": "Nome",
        "phone": "WhatsApp",
        "location": "Localização",
        "issue": "Ajuda necessária",
        "message": "O que aconteceu"
      },
      "validation": {
        "name": "Introduza o seu nome (mín. 2 caracteres)",
        "phone": "Introduza um número de WhatsApp válido",
        "message": "Descreva o que aconteceu (mín. 5 caracteres)"
      }
    },
    "footer": {
      "tagline": "Apoio de serralharia de emergência 24/7 em Edinburgh, Glasgow e áreas circundantes. Apoio escrito por WhatsApp.",
      "contactTitle": "Contacto",
      "coverageTitle": "Áreas de serviço",
      "aboutTitle": "Sobre",
      "legal": "Serviço de serralharia independente em nome individual.",
      "legal2": "A UNLockSmiths é um serviço de serralharia independente por conta própria que serve Edinburgh e áreas circundantes.",
      "rights": "Todos os direitos reservados.",
      "website": "Website"
    },
    "social": {
      "title": "Siga-nos e envie-nos mensagem",
      "sub": "Estamos disponíveis 24 horas por dia, 7 dias por semana, para serviços de serralharia de emergência em Edinburgh, Glasgow e áreas circundantes."
    },
    "chat": {
      "title": "Assistente UNLockSmiths",
      "subtitle": "Online — responde 24/7",
      "welcome": "Olá! Sou o assistente da UNLockSmiths. Pergunte-me qualquer coisa: serviços, zonas, disponibilidade…",
      "suggestions": [
        "Estão disponíveis agora?",
        "Cobrem a minha zona?",
        "Como posso pedir ajuda?"
      ],
      "placeholder": "Escreva a sua pergunta…",
      "error": "Desculpe, algo correu mal. Tente novamente ou envie-nos mensagem no WhatsApp.",
      "open": "Fale com o nosso assistente"
    },
    "float": {
      "label": "Envie-nos mensagem no WhatsApp",
      "waMessage": "Hi! I need a locksmith. My situation: "
    },
    "video": {
      "title": "Ficou trancado do lado de fora? A ajuda está a uma mensagem.",
      "sub": "Veja como funciona em 20 segundos: envie mensagem no WhatsApp, a sua localização e uma foto, e acorde o preço por escrito antes de começarmos.",
      "unmute": "Ativar som",
      "mute": "Silenciar",
      "aria": "Vídeo promocional UNLockSmiths: chaveiro de emergência 24/7 em Edimburgo — fale connosco no WhatsApp"
    },
    "aboutMe": {
      "label": "Sobre mim",
      "title": "Conheça o seu chaveiro",
      "quote": "Olá, sou o Alfonso, o seu chaveiro local em Edimburgo. Acordo o preço consigo por escrito antes de começar, para não haver surpresas."
    }
  },
  uk: {
    "meta": {
      "title": "Цілодобовий аварійний слюсар Edinburgh | UNLockSmiths",
      "description": "UNLockSmiths надає цілодобову письмову підтримку через WhatsApp для аварійного відкривання житла, бізнесу та авто в Edinburgh, Glasgow і прилеглих районах. Напишіть нам, вказавши своє місцезнаходження та надіславши фото."
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "Доступно 24/7 — письмова підтримка через WhatsApp",
      "line1": "Зачинилися?",
      "line2": "Напишіть UNLockSmiths",
      "line3": "зараз.",
      "sub1": "Цілодобова аварійна слюсарна допомога в Edinburgh, Glasgow і прилеглих районах.",
      "sub2": "Надішліть нам своє місцезнаходження та опишіть, що сталося. Ви також можете надіслати фото дверей, замка або автомобіля. Ми відповідаємо письмово у WhatsApp.",
      "whatsapp": "Напишіть нам у WhatsApp",
      "quote": "Отримати письмову ціну",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "trust": [
        "Доступно 24/7",
        "Письмова підтримка через WhatsApp",
        "Ціну погоджено до початку робіт"
      ],
      "priceLine": "Надішліть фото й отримайте чітку письмову ціну до початку будь-яких робіт."
    },
    "marquee": [
      "ЦІЛОДОБОВИЙ АВАРІЙНИЙ СЛЮСАР EDINBURGH",
      "ДІМ · БІЗНЕС · АВАРІЙНЕ ВІДКРИВАННЯ АВТО",
      "ПИСЬМОВА ПІДТРИМКА ЧЕРЕЗ WHATSAPP",
      "EDINBURGH · GLASGOW · ПРИЛЕГЛІ РАЙОНИ",
      "ЦІНУ ПОГОДЖЕНО ДО ПОЧАТКУ РОБІТ",
      "ЗАМІНА ТА РЕМОНТ ЗАМКІВ",
      "НЕЗАЛЕЖНИЙ І МІСЦЕВИЙ"
    ],
    "services": {
      "title": "Наші слюсарні послуги",
      "sub": "Аварійна слюсарна допомога для житла, бізнесу та автомобілів в Edinburgh, Glasgow і прилеглих районах — усе узгоджується письмово у WhatsApp.",
      "categories": [
        {
          "id": "home",
          "title": "Слюсар для дому",
          "desc": "Зачинилися ззовні в Edinburgh? Аварійне відкривання дверей, заміна та ремонт замків для вашого дому.",
          "items": [
            "Відкривання житла при зачиненні",
            "Аварійне відкривання дверей",
            "Заміна замків",
            "Ремонт замків",
            "Допомога при втраті ключів",
            "Ремонт після зламу",
            "Встановлення нових замків"
          ]
        },
        {
          "id": "business",
          "title": "Слюсар для бізнесу",
          "desc": "Зачинилися ззовні з бізнес-приміщення або потрібна заміна комерційного замка — аварійний доступ до офісів і магазинів.",
          "items": [
            "Відкривання офісів при зачиненні",
            "Відкривання магазинів і бізнес-приміщень при зачиненні",
            "Заміна комерційних замків",
            "Ремонт замків для бізнесу",
            "Аварійний доступ до офісів і магазинів"
          ]
        },
        {
          "id": "auto",
          "title": "Автослюсар",
          "desc": "Зачинилися ззовні від авто в Edinburgh або Glasgow? Відкривання автомобіля, якщо ключі залишилися всередині.",
          "items": [
            "Відкривання авто при зачиненні",
            "Відкривання автомобіля",
            "Ключі замкнені всередині автомобіля"
          ]
        }
      ],
      "book": "Напишіть нам щодо цього"
    },
    "how": {
      "title": "Як це працює",
      "sub": "Три прості кроки — усе письмово.",
      "steps": [
        {
          "title": "Напишіть нам у WhatsApp",
          "desc": "Розкажіть, що сталося і де ви перебуваєте."
        },
        {
          "title": "Надішліть фото, якщо це допоможе",
          "desc": "Надішліть фото дверей, замка або автомобіля, якщо це безпечно."
        },
        {
          "title": "Погодьте ціну письмово",
          "desc": "Жодні роботи не починаються, доки ви не погодите ціну."
        }
      ]
    },
    "trust": {
      "title": "Чіткі ціни. Письмове спілкування. Без тиску.",
      "body": "Ми письмово пояснюємо ситуацію до початку робіт. Ви погоджуєте ціну до того, як ми почнемо. Якщо ви не впевнені, яка саме послуга вам потрібна, напишіть нам — ми підкажемо.",
      "cta": "Зв’яжіться з нами письмово"
    },
    "coverage": {
      "title": "Зони обслуговування",
      "sub": "Ми переважно працюємо в Edinburgh, а також доступні в Glasgow і навколишніх містах. Напишіть нам своє місцезнаходження, і ми підтвердимо, чи можемо допомогти.",
      "main": "Основна зона обслуговування",
      "additional": "Також доступно в",
      "cta": "Не впевнені, чи ми обслуговуємо ваш район? Надішліть нам своє місцезнаходження.",
      "ctaBtn": "Напишіть нам у WhatsApp"
    },
    "about": {
      "title": "Незалежний місцевий слюсар",
      "p1": "UNLockSmiths — це незалежна приватна слюсарна служба, що обслуговує Edinburgh і прилеглі райони.",
      "p2": "Ми працюємо письмово: ви описуєте проблему, надсилаєте своє місцезнаходження та фото, а ми підтверджуємо ціну до початку будь-яких робіт. Аварійне відкривання житла, бізнесу та авто, заміна й ремонт замків — удень і вночі, за наявності можливості.",
      "overlay": "Ключі замкнулися у вашому авто? Напишіть нам у WhatsApp.",
      "stats": [
        {
          "value": "24/7",
          "label": "аварійна підтримка, за наявності можливості"
        },
        {
          "value": "WhatsApp",
          "label": "письмова підтримка — ціну погоджено до початку робіт"
        }
      ]
    },
    "reviews": {
      "title": "Відгуки Google",
      "body": "Відгуки Google незабаром з’являться.",
      "note": "Наш профіль Google Business зараз проходить перевірку. Щойно він стане активним, ви зможете читати та залишати тут відгуки.",
      "button": "Залишити відгук у Google"
    },
    "faq": {
      "title": "Поширені запитання",
      "items": [
        {
          "id": "written",
          "q": "Чи надаєте ви письмову підтримку через WhatsApp?",
          "a": "Так. Ви можете описати свою ситуацію, надіслати місцезнаходження та поділитися фото через WhatsApp."
        },
        {
          "id": "night",
          "q": "Чи працюєте ви вночі?",
          "a": "Ми надаємо аварійну підтримку 24/7, залежно від доступності у вашому районі."
        },
        {
          "id": "request",
          "q": "Як звернутися по допомогу?",
          "a": "Напишіть нам у WhatsApp, вказавши своє місцезнаходження та опис проблеми."
        },
        {
          "id": "photo",
          "q": "Чи потрібно надсилати фото?",
          "a": "Фото може допомогти нам зрозуміти ситуацію, але воно потрібне не завжди."
        },
        {
          "id": "price",
          "q": "Чи знатиму я ціну до початку робіт?",
          "a": "Ми пояснюємо ціну до початку робіт. Ви погоджуєте її до того, як ми почнемо."
        },
        {
          "id": "car",
          "q": "Чи можете ви відкрити зачинений автомобіль?",
          "a": "Ми надаємо допомогу при зачиненні авто, де це доступно. Перед відкриванням автомобіля ми можемо попросити підтвердження права власності або дозволу."
        },
        {
          "id": "business",
          "q": "Чи обслуговуєте ви бізнес?",
          "a": "Так. Ми допомагаємо з аварійним відкриванням офісів, магазинів і бізнес-приміщень там, де це доступно."
        }
      ]
    },
    "contact": {
      "title": "Надішліть свій запит письмово",
      "sub": "Заповніть це, і ми відкриємо WhatsApp з готовими до надсилання вашими даними. Ви зможете прикріпити фото в чаті.",
      "name": "Ім’я",
      "phone": "Номер WhatsApp",
      "location": "Район або поштовий індекс",
      "issue": "З чим вам потрібна допомога?",
      "issueOptions": [
        "Зачинився ззовні від дому",
        "Зачинився ззовні від бізнес-приміщення",
        "Зачинився ззовні від авто",
        "Заміна або ремонт замка",
        "Ремонт після зламу",
        "Втрачені ключі",
        "Інше"
      ],
      "message": "Опишіть, що сталося",
      "photoHint": "Є фото? Прикріпіть його в чаті WhatsApp після надсилання — це допоможе нам зрозуміти ситуацію.",
      "submit": "Надіслати запит через WhatsApp",
      "sending": "Підготовка…",
      "successTitle": "Запит готовий",
      "successBody": "WhatsApp відкривається з вашими даними. За потреби прикріпіть фото в чаті.",
      "errorTitle": "Щось пішло не так",
      "errorBody": "Будь ласка, спробуйте ще раз або напишіть нам напряму у WhatsApp.",
      "whatsappCta": "Напишіть нам у WhatsApp",
      "emailCta": "Надішліть нам електронного листа",
      "photosCta": "Надіслати фото у WhatsApp",
      "writingCta": "Зв’яжіться з нами письмово",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "waPhotoMessage": "Hi! I'm sending photos of my door, lock or vehicle. My location is: ",
      "waLabels": {
        "intro": "Привіт! Мені потрібен слюсар.",
        "name": "Ім’я",
        "phone": "WhatsApp",
        "location": "Місцезнаходження",
        "issue": "Потрібна допомога",
        "message": "Що сталося"
      },
      "validation": {
        "name": "Будь ласка, введіть своє ім’я (мін. 2 символи)",
        "phone": "Будь ласка, введіть дійсний номер WhatsApp",
        "message": "Будь ласка, опишіть, що сталося (мін. 5 символів)"
      }
    },
    "footer": {
      "tagline": "Цілодобова аварійна слюсарна підтримка в Edinburgh, Glasgow і прилеглих районах. Письмова підтримка через WhatsApp.",
      "contactTitle": "Контакти",
      "coverageTitle": "Зони обслуговування",
      "aboutTitle": "Про нас",
      "legal": "Незалежна приватна слюсарна служба.",
      "legal2": "UNLockSmiths — це незалежна приватна слюсарна служба, що обслуговує Edinburgh і прилеглі райони.",
      "rights": "Усі права захищено.",
      "website": "Вебсайт"
    },
    "social": {
      "title": "Слідкуйте за нами та пишіть нам",
      "sub": "Ми доступні 24 години на добу, 7 днів на тиждень для аварійних слюсарних послуг в Edinburgh, Glasgow і прилеглих районах."
    },
    "chat": {
      "title": "Помічник UNLockSmiths",
      "subtitle": "Онлайн — відповідає 24/7",
      "welcome": "Привіт! Я помічник UNLockSmiths. Запитайте мене про що завгодно: послуги, райони, доступність…",
      "suggestions": [
        "Ви зараз доступні?",
        "Ви обслуговуєте мій район?",
        "Як звернутися по допомогу?"
      ],
      "placeholder": "Введіть своє запитання…",
      "error": "Вибачте, щось пішло не так. Спробуйте ще раз або напишіть нам у WhatsApp.",
      "open": "Почати чат з нашим помічником"
    },
    "float": {
      "label": "Напишіть нам у WhatsApp",
      "waMessage": "Hi! I need a locksmith. My situation: "
    },
    "video": {
      "title": "Замкнули двері? Допомога — за одне повідомлення.",
      "sub": "Подивіться, як це працює за 20 секунд: напишіть у WhatsApp, надішліть локацію та фото і погодьте ціну письмово до початку робіт.",
      "unmute": "Увімкнути звук",
      "mute": "Вимкнути звук",
      "aria": "Промовідео UNLockSmiths: аварійний слюсар 24/7 в Единбурзі — пишіть у WhatsApp"
    },
    "aboutMe": {
      "label": "Про мене",
      "title": "Ваш слюсар",
      "quote": "Привіт, я Альфонсо, ваш місцевий слюсар в Единбурзі. Я узгоджую з вами ціну письмово до початку роботи, тож жодних сюрпризів."
    }
  },
  ro: {
    "meta": {
      "title": "Lăcătuș de urgență 24/7 Edinburgh | UNLockSmiths",
      "description": "UNLockSmiths oferă asistență scrisă 24/7 pe WhatsApp pentru blocări de locuință, afacere și mașină în Edinburgh, Glasgow și zonele din jur. Trimite-ne locația ta și fotografii."
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "Disponibil 24/7 — asistență scrisă pe WhatsApp",
      "line1": "Ai rămas pe dinafară?",
      "line2": "Trimite mesaj la UNLockSmiths",
      "line3": "acum.",
      "sub1": "Asistență de urgență 24/7 de lăcătuș în Edinburgh, Glasgow și zonele din jur.",
      "sub2": "Trimite-ne locația ta și explică ce s-a întâmplat. Poți trimite și fotografii cu ușa, încuietoarea sau vehiculul. Răspundem în scris pe WhatsApp.",
      "whatsapp": "Scrie-ne pe WhatsApp",
      "quote": "Primește o ofertă scrisă",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "trust": [
        "Disponibil 24/7",
        "Asistență scrisă pe WhatsApp",
        "Prețul este stabilit înainte de începerea lucrării"
      ],
      "priceLine": "Trimite o poză și primești un preț clar în scris înainte de orice lucrare."
    },
    "marquee": [
      "LĂCĂTUȘ DE URGENȚĂ 24/7 EDINBURGH",
      "LOCUINȚĂ · AFACERE · DEBLOCARE AUTO",
      "ASISTENȚĂ SCRISĂ PE WHATSAPP",
      "EDINBURGH · GLASGOW · ZONELE DIN JUR",
      "PREȚ STABILIT ÎNAINTE DE ÎNCEPEREA LUCRĂRII",
      "SCHIMBARE ȘI REPARAȚII ÎNCUIETORI",
      "INDEPENDENT ȘI LOCAL"
    ],
    "services": {
      "title": "Serviciile noastre de lăcătușerie",
      "sub": "Ajutor de urgență pentru locuințe, afaceri și vehicule în Edinburgh, Glasgow și zonele din jur — stabilit în scris pe WhatsApp.",
      "categories": [
        {
          "id": "home",
          "title": "Lăcătuș pentru locuințe",
          "desc": "Ai rămas blocat afară din casă în Edinburgh? Deschidere de urgență a ușii, schimbare și reparații de încuietori pentru locuința ta.",
          "items": [
            "Deblocări de locuințe",
            "Deschidere de urgență a ușii",
            "Schimbare de încuietori",
            "Reparații de încuietori",
            "Asistență pentru chei pierdute",
            "Reparații după efracție",
            "Montaj de încuietori noi"
          ]
        },
        {
          "id": "business",
          "title": "Lăcătuș pentru afaceri",
          "desc": "Blocare la sediu sau schimbare de încuietori comerciale — acces de urgență pentru birouri și magazine.",
          "items": [
            "Deblocări de birouri",
            "Deblocări de magazine și afaceri",
            "Schimbare de încuietori comerciale",
            "Reparații de încuietori pentru afaceri",
            "Acces de urgență pentru birouri și magazine"
          ]
        },
        {
          "id": "auto",
          "title": "Lăcătuș auto",
          "desc": "Ai rămas blocat afară din mașină în Edinburgh sau Glasgow? Deschidere vehicul când cheile au rămas înăuntru.",
          "items": [
            "Deblocări auto",
            "Deschidere vehicul",
            "Chei blocate în interiorul vehiculului"
          ]
        }
      ],
      "book": "Scrie-ne despre acest serviciu"
    },
    "how": {
      "title": "Cum funcționează",
      "sub": "Trei pași simpli — totul în scris.",
      "steps": [
        {
          "title": "Scrie-ne pe WhatsApp",
          "desc": "Spune-ne ce s-a întâmplat și unde te afli."
        },
        {
          "title": "Trimite fotografii dacă ajută",
          "desc": "Trimite o fotografie a ușii, încuietorii sau vehiculului dacă este sigur să faci asta."
        },
        {
          "title": "Stabilește prețul în scris",
          "desc": "Nu începem nicio lucrare până nu ești de acord cu prețul."
        }
      ]
    },
    "trust": {
      "title": "Prețuri clare. Comunicare scrisă. Fără presiune.",
      "body": "Explicăm situația în scris înainte de a începe lucrul. Ești de acord cu prețul înainte să începem. Dacă nu ești sigur ce serviciu ai nevoie, scrie-ne și te vom ghida.",
      "cta": "Contactează-ne în scris"
    },
    "coverage": {
      "title": "Zone deservite",
      "sub": "Deservim în principal Edinburgh, cu disponibilitate în Glasgow și orașele din jur. Trimite-ne locația ta și îți vom confirma dacă te putem ajuta.",
      "main": "Zona principală de servicii",
      "additional": "Disponibil și în",
      "cta": "Nu ești sigur dacă acoperim zona ta? Trimite-ne locația.",
      "ctaBtn": "Scrie-ne pe WhatsApp"
    },
    "about": {
      "title": "Un lăcătuș local independent",
      "p1": "UNLockSmiths este un serviciu independent de lăcătușerie prestat de un profesionist independent, care deservește Edinburgh și zonele din jur.",
      "p2": "Lucrăm în scris: explici problema, trimiți locația și fotografiile, iar noi confirmăm prețul înainte de începerea oricărei lucrări. Deblocări de locuințe, afaceri și mașini, schimbări și reparații de încuietori — zi sau noapte, în funcție de disponibilitate.",
      "overlay": "Cheile au rămas în mașină? Scrie-ne pe WhatsApp.",
      "stats": [
        {
          "value": "24/7",
          "label": "asistență de urgență, în funcție de disponibilitate"
        },
        {
          "value": "WhatsApp",
          "label": "asistență scrisă — prețul este stabilit înainte de începerea lucrării"
        }
      ]
    },
    "reviews": {
      "title": "Recenzii Google",
      "body": "Recenziile Google vor apărea în curând.",
      "note": "Profilul nostru Google Business este în curs de verificare. După ce va fi activ, vei putea citi și lăsa recenzii aici.",
      "button": "Lasă-ne o recenzie pe Google"
    },
    "faq": {
      "title": "Întrebări frecvente",
      "items": [
        {
          "id": "written",
          "q": "Oferiți asistență scrisă pe WhatsApp?",
          "a": "Da. Ne poți explica situația, trimite locația ta și partaja fotografii prin WhatsApp."
        },
        {
          "id": "night",
          "q": "Lucrați noaptea?",
          "a": "Oferim asistență de urgență 24/7, în funcție de disponibilitatea din zona ta."
        },
        {
          "id": "request",
          "q": "Cum solicit ajutor?",
          "a": "Scrie-ne pe WhatsApp cu locația ta și o descriere a problemei."
        },
        {
          "id": "photo",
          "q": "Trebuie să trimit o fotografie?",
          "a": "O fotografie ne poate ajuta să înțelegem situația, dar nu este întotdeauna necesară."
        },
        {
          "id": "price",
          "q": "Voi ști prețul înainte de începerea lucrării?",
          "a": "Îți explicăm prețul înainte de începerea lucrării. Îți dai acordul înainte să începem."
        },
        {
          "id": "car",
          "q": "Puteți deschide o mașină încuiată?",
          "a": "Oferim asistență pentru deblocări auto acolo unde este disponibilă. Este posibil să cerem dovada proprietății sau permisiunea înainte de a deschide un vehicul."
        },
        {
          "id": "business",
          "q": "Deserviți și afaceri?",
          "a": "Da. Ajutăm cu deblocări de birouri, magazine și afaceri, acolo unde este disponibil."
        }
      ]
    },
    "contact": {
      "title": "Trimite solicitarea în scris",
      "sub": "Completează aici și vom deschide WhatsApp cu detaliile tale pregătite pentru trimitere. Poți atașa fotografii în chat.",
      "name": "Nume",
      "phone": "Număr WhatsApp",
      "location": "Zonă sau cod poștal",
      "issue": "Cu ce ai nevoie de ajutor?",
      "issueOptions": [
        "Blocat afară din locuință",
        "Blocat afară din afacerea mea",
        "Blocat afară din mașină",
        "Schimbare sau reparație de încuietoare",
        "Reparație după efracție",
        "Chei pierdute",
        "Altceva"
      ],
      "message": "Descrie ce s-a întâmplat",
      "photoHint": "Ai o fotografie? Atașeaz-o în chatul WhatsApp după trimitere — ne ajută să înțelegem situația.",
      "submit": "Trimite solicitarea prin WhatsApp",
      "sending": "Se pregătește…",
      "successTitle": "Solicitare pregătită",
      "successBody": "WhatsApp se deschide cu detaliile tale. Atașează fotografii în chat dacă ajută.",
      "errorTitle": "Ceva nu a mers bine",
      "errorBody": "Te rugăm să încerci din nou sau să ne scrii direct pe WhatsApp.",
      "whatsappCta": "Scrie-ne pe WhatsApp",
      "emailCta": "Trimite-ne un e-mail",
      "photosCta": "Trimite fotografii pe WhatsApp",
      "writingCta": "Contactează-ne în scris",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "waPhotoMessage": "Hi! I'm sending photos of my door, lock or vehicle. My location is: ",
      "waLabels": {
        "intro": "Salut! Am nevoie de un lăcătuș.",
        "name": "Nume",
        "phone": "WhatsApp",
        "location": "Locație",
        "issue": "Ajutor necesar",
        "message": "Ce s-a întâmplat"
      },
      "validation": {
        "name": "Te rugăm să introduci numele tău (min. 2 caractere)",
        "phone": "Te rugăm să introduci un număr WhatsApp valid",
        "message": "Te rugăm să descrii ce s-a întâmplat (min. 5 caractere)"
      }
    },
    "footer": {
      "tagline": "Asistență de urgență 24/7 de lăcătuș în Edinburgh, Glasgow și zonele din jur. Asistență scrisă pe WhatsApp.",
      "contactTitle": "Contact",
      "coverageTitle": "Zone deservite",
      "aboutTitle": "Despre",
      "legal": "Serviciu independent de lăcătușerie, persoană fizică autorizată.",
      "legal2": "UNLockSmiths este un serviciu independent de lăcătușerie prestat de un profesionist independent, care deservește Edinburgh și zonele din jur.",
      "rights": "Toate drepturile rezervate.",
      "website": "Website"
    },
    "social": {
      "title": "Urmărește-ne și scrie-ne",
      "sub": "Suntem disponibili 24 de ore pe zi, 7 zile pe săptămână pentru servicii de lăcătușerie de urgență în Edinburgh, Glasgow și zonele din jur."
    },
    "chat": {
      "title": "Asistent UNLockSmiths",
      "subtitle": "Online — răspunde 24/7",
      "welcome": "Salut! Sunt asistentul UNLockSmiths. Întreabă-mă orice: servicii, zone, disponibilitate…",
      "suggestions": [
        "Sunteți disponibili acum?",
        "Acoperiți zona mea?",
        "Cum solicit ajutor?"
      ],
      "placeholder": "Scrie întrebarea ta…",
      "error": "Ne pare rău, ceva nu a mers bine. Încearcă din nou sau scrie-ne pe WhatsApp.",
      "open": "Vorbește cu asistentul nostru"
    },
    "float": {
      "label": "Scrie-ne pe WhatsApp",
      "waMessage": "Hi! I need a locksmith. My situation: "
    },
    "video": {
      "title": "Ai rămas blocat afară? Ajutorul e la un mesaj distanță.",
      "sub": "Vezi cum funcționează în 20 de secunde: scrie-ne pe WhatsApp, trimite locația și o poză și stabilim prețul în scris înainte să începem.",
      "unmute": "Pornește sunetul",
      "mute": "Oprește sunetul",
      "aria": "Video promoțional UNLockSmiths: lăcătuș de urgență 24/7 în Edinburgh — scrie-ne pe WhatsApp"
    },
    "aboutMe": {
      "label": "Despre mine",
      "title": "Lăcătușul tău",
      "quote": "Salut, sunt Alfonso, lăcătușul tău local din Edinburgh. Stabilesc prețul cu tine în scris înainte de a începe, ca să nu existe surprize."
    }
  },
  zh: {
    "meta": {
      "title": "爱丁堡 24/7 紧急锁匠 | UNLockSmiths",
      "description": "UNLockSmiths 为爱丁堡、格拉斯哥及周边地区的住宅、商铺和汽车锁闭情况提供 24/7 WhatsApp 书面支持。把您的位置和照片发给我们。"
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "24/7 可用 — WhatsApp 书面支持",
      "line1": "被锁在门外？",
      "line2": "立即联系 UNLockSmiths",
      "line3": "。",
      "sub1": "为爱丁堡、格拉斯哥及周边地区提供 24/7 紧急锁匠支持。",
      "sub2": "把您的位置发给我们，并说明发生了什么。您也可以发送门、锁或车辆的照片。我们会通过 WhatsApp 书面回复。",
      "whatsapp": "通过 WhatsApp 联系我们",
      "quote": "获取书面报价",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "trust": [
        "24/7 可用",
        "WhatsApp 书面支持",
        "开工前先确认价格"
      ],
      "priceLine": "发送照片，在开工前获得清晰的书面报价。"
    },
    "marquee": [
      "24/7 紧急锁匠 爱丁堡",
      "住宅 · 商铺 · 汽车开锁",
      "WHATSAPP 书面支持",
      "爱丁堡 · 格拉斯哥 · 周边地区",
      "开工前先确认价格",
      "换锁与修锁",
      "独立经营 · 本地服务"
    ],
    "services": {
      "title": "我们的锁匠服务",
      "sub": "为爱丁堡、格拉斯哥及周边地区的住宅、商铺和车辆提供紧急锁匠帮助 — 通过 WhatsApp 以书面方式安排。",
      "categories": [
        {
          "id": "home",
          "title": "住宅锁匠",
          "desc": "在爱丁堡被锁在门外？为您的住宅提供紧急开门、换锁和修锁服务。",
          "items": [
            "住宅开锁",
            "紧急开门",
            "更换门锁",
            "门锁维修",
            "钥匙遗失协助",
            "入室盗窃后维修",
            "安装新锁"
          ]
        },
        {
          "id": "business",
          "title": "商用锁匠",
          "desc": "商铺或办公场所被锁在门外，或需要更换商用门锁 — 为办公室和店铺提供紧急开门服务。",
          "items": [
            "办公室开锁",
            "店铺和商铺开锁",
            "商用门锁更换",
            "商用门锁维修",
            "办公室和店铺紧急开门"
          ]
        },
        {
          "id": "auto",
          "title": "汽车锁匠",
          "desc": "在爱丁堡或格拉斯哥遇到汽车锁闭？当钥匙锁在车内时，可提供车辆开锁服务。",
          "items": [
            "汽车开锁",
            "车辆开锁",
            "钥匙锁在车内"
          ]
        }
      ],
      "book": "就此服务给我们发消息"
    },
    "how": {
      "title": "服务流程",
      "sub": "简单三步 — 全程书面沟通。",
      "steps": [
        {
          "title": "通过 WhatsApp 联系我们",
          "desc": "告诉我们发生了什么，以及您在哪里。"
        },
        {
          "title": "如有帮助可发送照片",
          "desc": "如果安全方便，可以发送门、锁或车辆的照片。"
        },
        {
          "title": "以书面方式确认价格",
          "desc": "在您确认价格前，我们不会开始工作。"
        }
      ]
    },
    "trust": {
      "title": "价格清晰，书面沟通，不施压。",
      "body": "在开始工作前，我们会先以书面形式说明情况。您先确认价格，我们才会开始。如果您不确定需要哪种服务，给我们发消息，我们会为您提供指引。",
      "cta": "以书面方式联系我们"
    },
    "coverage": {
      "title": "服务区域",
      "sub": "我们主要服务爱丁堡，在格拉斯哥及周边城镇也可视情况提供服务。把您的位置发给我们，我们会确认是否能提供帮助。",
      "main": "主要服务区域",
      "additional": "也可服务于",
      "cta": "不确定我们是否覆盖您所在地区？把您的位置发给我们。",
      "ctaBtn": "通过 WhatsApp 联系我们"
    },
    "about": {
      "title": "独立本地锁匠",
      "p1": "UNLockSmiths 是一家独立个体经营的锁匠服务，服务于爱丁堡及周边地区。",
      "p2": "我们采用书面沟通方式：您说明问题，发送您的位置和照片，我们会在开始任何工作前确认价格。提供住宅、商铺和汽车开锁、换锁及修锁服务 — 无论白天或夜晚，均视可用情况而定。",
      "overlay": "钥匙锁在车里了？通过 WhatsApp 联系我们。",
      "stats": [
        {
          "value": "24/7",
          "label": "紧急支持，视可用情况而定"
        },
        {
          "value": "WhatsApp",
          "label": "书面支持 — 开工前先确认价格"
        }
      ]
    },
    "reviews": {
      "title": "Google 评价",
      "body": "Google 评价即将上线。",
      "note": "我们的 Google Business Profile 正在验证中。上线后，您就可以在这里查看和留下评价。",
      "button": "在 Google 上给我们留下评价"
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "id": "written",
          "q": "你们提供 WhatsApp 书面支持吗？",
          "a": "是的。您可以通过 WhatsApp 说明您的情况、发送您的位置并分享照片。"
        },
        {
          "id": "night",
          "q": "你们晚上工作吗？",
          "a": "我们提供 24/7 紧急支持，具体视您所在地区的可用情况而定。"
        },
        {
          "id": "request",
          "q": "我如何请求帮助？",
          "a": "请通过 WhatsApp 把您的位置和问题描述发给我们。"
        },
        {
          "id": "photo",
          "q": "我需要发送照片吗？",
          "a": "照片可以帮助我们了解情况，但并非总是必需。"
        },
        {
          "id": "price",
          "q": "我能在开工前知道价格吗？",
          "a": "我们会在开工前说明价格。您确认后我们才会开始。"
        },
        {
          "id": "car",
          "q": "你们可以打开被锁住的汽车吗？",
          "a": "在可服务的情况下，我们提供汽车开锁协助。在开启车辆前，我们可能会要求提供所有权证明或授权证明。"
        },
        {
          "id": "business",
          "q": "你们为商家提供服务吗？",
          "a": "是的。在可服务的情况下，我们可协助办公室、店铺和商铺开锁。"
        }
      ]
    },
    "contact": {
      "title": "以书面方式发送您的请求",
      "sub": "填写此表单后，我们会打开 WhatsApp，并为您准备好可直接发送的信息。您可以在聊天中附上照片。",
      "name": "姓名",
      "phone": "WhatsApp 号码",
      "location": "区域或邮编",
      "issue": "您需要哪方面的帮助？",
      "issueOptions": [
        "被锁在家门外",
        "被锁在商铺门外",
        "被锁在车外",
        "换锁或修锁",
        "入室盗窃后维修",
        "钥匙遗失",
        "其他"
      ],
      "message": "请描述发生了什么",
      "photoHint": "有照片吗？发送后可在 WhatsApp 聊天中附上 — 这有助于我们了解情况。",
      "submit": "通过 WhatsApp 发送请求",
      "sending": "准备中…",
      "successTitle": "请求已准备好",
      "successBody": "WhatsApp 正在打开，您的信息已准备就绪。如有帮助，可在聊天中附上照片。",
      "errorTitle": "出了点问题",
      "errorBody": "请重试，或直接通过 WhatsApp 联系我们。",
      "whatsappCta": "通过 WhatsApp 联系我们",
      "emailCta": "给我们发送电子邮件",
      "photosCta": "通过 WhatsApp 发送照片",
      "writingCta": "以书面方式联系我们",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "waPhotoMessage": "Hi! I'm sending photos of my door, lock or vehicle. My location is: ",
      "waLabels": {
        "intro": "Hi! I need a locksmith.",
        "name": "姓名",
        "phone": "WhatsApp",
        "location": "位置",
        "issue": "所需帮助",
        "message": "发生了什么"
      },
      "validation": {
        "name": "请输入您的姓名（至少 2 个字符）",
        "phone": "请输入有效的 WhatsApp 号码",
        "message": "请描述发生了什么（至少 5 个字符）"
      }
    },
    "footer": {
      "tagline": "为爱丁堡、格拉斯哥及周边地区提供 24/7 紧急锁匠支持。WhatsApp 书面支持。",
      "contactTitle": "联系方式",
      "coverageTitle": "服务区域",
      "aboutTitle": "关于我们",
      "legal": "独立个体经营锁匠服务。",
      "legal2": "UNLockSmiths 是一家独立个体经营的锁匠服务，服务于爱丁堡及周边地区。",
      "rights": "版权所有。",
      "website": "网站"
    },
    "social": {
      "title": "关注我们并给我们发消息",
      "sub": "我们每周 7 天、每天 24 小时为爱丁堡、格拉斯哥及周边地区提供紧急锁匠服务。"
    },
    "chat": {
      "title": "UNLockSmiths 助手",
      "subtitle": "在线 — 24/7 回复",
      "welcome": "您好！我是 UNLockSmiths 助手。您可以问我任何问题：服务、区域、可用时间……",
      "suggestions": [
        "你们现在可以服务吗？",
        "你们覆盖我所在的地区吗？",
        "我该如何请求帮助？"
      ],
      "placeholder": "输入您的问题…",
      "error": "抱歉，出了点问题。请重试，或通过 WhatsApp 联系我们。",
      "open": "与我们的助手聊天"
    },
    "float": {
      "label": "通过 WhatsApp 联系我们",
      "waMessage": "Hi! I need a locksmith. My situation: "
    },
    "video": {
      "title": "被锁在门外？发一条消息即可获得帮助。",
      "sub": "20 秒了解流程：通过 WhatsApp 联系我们，发送位置和照片，开工前以书面形式确认价格。",
      "unmute": "开启声音",
      "mute": "静音",
      "aria": "UNLockSmiths 宣传视频：爱丁堡 24/7 紧急开锁服务 — 通过 WhatsApp 联系我们"
    },
    "aboutMe": {
      "label": "关于我",
      "title": "认识您的开锁师傅",
      "quote": "您好，我是 Alfonso，您在爱丁堡的本地开锁师傅。开工前我会以书面形式与您确认价格，绝无意外收费。"
    }
  },
  hi: {
    "meta": {
      "title": "24/7 आपातकालीन लॉकस्मिथ Edinburgh | UNLockSmiths",
      "description": "UNLockSmiths Edinburgh, Glasgow और आसपास के क्षेत्रों में घर, व्यवसाय और कार लॉकआउट के लिए 24/7 लिखित WhatsApp सहायता प्रदान करता है। हमें अपना स्थान और फ़ोटो के साथ संदेश भेजें।"
    },
    "header": {
      "whatsapp": "WhatsApp"
    },
    "hero": {
      "badge": "24/7 उपलब्ध — लिखित WhatsApp सहायता",
      "line1": "बाहर लॉक हो गए?",
      "line2": "UNLockSmiths को संदेश भेजें",
      "line3": "अभी।",
      "sub1": "Edinburgh, Glasgow और आसपास के क्षेत्रों में 24/7 आपातकालीन लॉकस्मिथ सहायता।",
      "sub2": "हमें अपना स्थान भेजें और बताएं क्या हुआ। आप दरवाज़े, ताले या वाहन की फ़ोटो भी भेज सकते हैं। हम WhatsApp पर लिखित में जवाब देते हैं।",
      "whatsapp": "हमें WhatsApp पर संदेश भेजें",
      "quote": "लिखित कोटेशन प्राप्त करें",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "trust": [
        "24/7 उपलब्ध",
        "लिखित WhatsApp सहायता",
        "काम शुरू होने से पहले कीमत तय"
      ],
      "priceLine": "फ़ोटो भेजें और कोई भी काम शुरू होने से पहले स्पष्ट लिखित कीमत पाएं।"
    },
    "marquee": [
      "24/7 इमरजेंसी लॉकस्मिथ EDINBURGH",
      "घर · व्यवसाय · कार लॉकआउट",
      "लिखित WHATSAPP सहायता",
      "EDINBURGH · GLASGOW · आसपास के क्षेत्र",
      "काम शुरू होने से पहले कीमत तय",
      "ताला बदलना और मरम्मत",
      "स्वतंत्र और स्थानीय"
    ],
    "services": {
      "title": "हमारी लॉकस्मिथ सेवाएँ",
      "sub": "Edinburgh, Glasgow और आसपास के क्षेत्रों में घरों, व्यवसायों और वाहनों के लिए आपातकालीन लॉकस्मिथ सहायता — WhatsApp पर लिखित रूप में व्यवस्थित।",
      "categories": [
        {
          "id": "home",
          "title": "होम लॉकस्मिथ",
          "desc": "Edinburgh में घर से बाहर लॉक हो गए? आपके घर के लिए आपातकालीन दरवाज़ा खोलना, ताला बदलना और मरम्मत।",
          "items": [
            "घर लॉकआउट",
            "आपातकालीन दरवाज़ा खोलना",
            "ताला बदलना",
            "ताला मरम्मत",
            "खोई हुई चाबी में सहायता",
            "चोरी के बाद मरम्मत",
            "नया ताला इंस्टॉलेशन"
          ]
        },
        {
          "id": "business",
          "title": "बिज़नेस लॉकस्मिथ",
          "desc": "बिज़नेस लॉकआउट या कमर्शियल ताला बदलना — दफ़्तरों और दुकानों के लिए आपातकालीन प्रवेश।",
          "items": [
            "ऑफिस लॉकआउट",
            "दुकान और व्यवसाय लॉकआउट",
            "कमर्शियल ताला बदलना",
            "व्यवसायों के लिए ताला मरम्मत",
            "दफ़्तरों और दुकानों के लिए आपातकालीन प्रवेश"
          ]
        },
        {
          "id": "auto",
          "title": "ऑटो लॉकस्मिथ",
          "desc": "Edinburgh या Glasgow में कार लॉकआउट? जब आपकी चाबियाँ वाहन के अंदर लॉक हों तब वाहन प्रवेश।",
          "items": [
            "कार लॉकआउट",
            "वाहन प्रवेश",
            "चाबियाँ वाहन के अंदर लॉक"
          ]
        }
      ],
      "book": "इस बारे में हमें संदेश भेजें"
    },
    "how": {
      "title": "यह कैसे काम करता है",
      "sub": "तीन आसान चरण — सब कुछ लिखित में।",
      "steps": [
        {
          "title": "हमें WhatsApp पर संदेश भेजें",
          "desc": "हमें बताएं क्या हुआ और आप कहाँ हैं।"
        },
        {
          "title": "यदि उपयोगी हो तो फ़ोटो भेजें",
          "desc": "यदि सुरक्षित हो, तो दरवाज़े, ताले या वाहन की फ़ोटो भेजें।"
        },
        {
          "title": "कीमत लिखित में तय करें",
          "desc": "जब तक आप कीमत पर सहमत नहीं होते, काम शुरू नहीं होता।"
        }
      ]
    },
    "trust": {
      "title": "स्पष्ट कीमतें। लिखित संवाद। बिना दबाव।",
      "body": "काम शुरू होने से पहले हम स्थिति को लिखित में समझाते हैं। शुरू करने से पहले आप कीमत पर सहमत होते हैं। यदि आपको पता नहीं कि कौन-सी सेवा चाहिए, हमें संदेश भेजें और हम आपका मार्गदर्शन करेंगे।",
      "cta": "हमसे लिखित में संपर्क करें"
    },
    "coverage": {
      "title": "सेवा क्षेत्र",
      "sub": "हम मुख्य रूप से Edinburgh में सेवा देते हैं, साथ ही Glasgow और आसपास के शहरों में उपलब्धता रखते हैं। हमें अपना स्थान भेजें और हम पुष्टि करेंगे कि क्या हम मदद कर सकते हैं।",
      "main": "मुख्य सेवा क्षेत्र",
      "additional": "यहाँ भी उपलब्ध",
      "cta": "पक्का नहीं कि हम आपके क्षेत्र को कवर करते हैं? हमें अपना स्थान भेजें।",
      "ctaBtn": "हमें WhatsApp पर संदेश भेजें"
    },
    "about": {
      "title": "एक स्वतंत्र स्थानीय लॉकस्मिथ",
      "p1": "UNLockSmiths एक स्वतंत्र स्व-रोज़गार लॉकस्मिथ सेवा है जो Edinburgh और आसपास के क्षेत्रों में सेवा देती है।",
      "p2": "हम लिखित रूप में काम करते हैं: आप समस्या बताते हैं, अपना स्थान और फ़ोटो भेजते हैं, और किसी भी काम की शुरुआत से पहले हम कीमत की पुष्टि करते हैं। घर, व्यवसाय और कार लॉकआउट, ताला बदलना और मरम्मत — दिन हो या रात, उपलब्धता के अधीन।",
      "overlay": "आपकी चाबियाँ कार में लॉक हो गई हैं? हमें WhatsApp पर संदेश भेजें।",
      "stats": [
        {
          "value": "24/7",
          "label": "आपातकालीन सहायता, उपलब्धता के अधीन"
        },
        {
          "value": "WhatsApp",
          "label": "लिखित सहायता — काम शुरू होने से पहले कीमत तय"
        }
      ]
    },
    "reviews": {
      "title": "Google समीक्षाएँ",
      "body": "Google समीक्षाएँ जल्द आ रही हैं।",
      "note": "हमारा Google Business Profile सत्यापित किया जा रहा है। जैसे ही यह लाइव होगा, आप यहाँ समीक्षाएँ पढ़ और छोड़ सकेंगे।",
      "button": "Google पर हमें समीक्षा दें"
    },
    "faq": {
      "title": "अक्सर पूछे जाने वाले सवाल",
      "items": [
        {
          "id": "written",
          "q": "क्या आप लिखित WhatsApp सहायता प्रदान करते हैं?",
          "a": "हाँ। आप अपनी स्थिति समझा सकते हैं, अपना स्थान भेज सकते हैं और WhatsApp पर फ़ोटो साझा कर सकते हैं।"
        },
        {
          "id": "night",
          "q": "क्या आप रात में काम करते हैं?",
          "a": "हम 24/7 आपातकालीन सहायता प्रदान करते हैं, आपके क्षेत्र में उपलब्धता के अधीन।"
        },
        {
          "id": "request",
          "q": "मैं सहायता का अनुरोध कैसे करूँ?",
          "a": "अपना स्थान और समस्या का विवरण देकर हमें WhatsApp पर संदेश भेजें।"
        },
        {
          "id": "photo",
          "q": "क्या मुझे फ़ोटो भेजनी होगी?",
          "a": "फ़ोटो से हमें स्थिति समझने में मदद मिल सकती है, लेकिन यह हमेशा आवश्यक नहीं होती।"
        },
        {
          "id": "price",
          "q": "क्या मुझे काम शुरू होने से पहले कीमत पता होगी?",
          "a": "काम शुरू होने से पहले हम कीमत बताते हैं। शुरू करने से पहले आप सहमति देते हैं।"
        },
        {
          "id": "car",
          "q": "क्या आप लॉक हुई कार खोल सकते हैं?",
          "a": "जहाँ उपलब्ध हो, हम कार लॉकआउट सहायता प्रदान करते हैं। वाहन खोलने से पहले हम स्वामित्व या अनुमति का प्रमाण माँग सकते हैं।"
        },
        {
          "id": "business",
          "q": "क्या आप व्यवसायों को सेवा देते हैं?",
          "a": "हाँ। जहाँ उपलब्ध हो, हम दफ़्तर, दुकान और व्यवसाय लॉकआउट में मदद करते हैं।"
        }
      ]
    },
    "contact": {
      "title": "अपना अनुरोध लिखित में भेजें",
      "sub": "इसे भरें और हम आपके विवरण के साथ WhatsApp खोल देंगे ताकि आप तुरंत भेज सकें। आप चैट में फ़ोटो संलग्न कर सकते हैं।",
      "name": "नाम",
      "phone": "WhatsApp नंबर",
      "location": "क्षेत्र या पोस्टकोड",
      "issue": "आपको किस बात में मदद चाहिए?",
      "issueOptions": [
        "मैं अपने घर से बाहर लॉक हो गया/गई हूँ",
        "मैं अपने व्यवसाय से बाहर लॉक हो गया/गई हूँ",
        "मैं अपनी कार से बाहर लॉक हो गया/गई हूँ",
        "ताला बदलना या मरम्मत",
        "चोरी के बाद मरम्मत",
        "चाबियाँ खो गईं",
        "अन्य"
      ],
      "message": "बताएं क्या हुआ",
      "photoHint": "क्या आपके पास फ़ोटो है? भेजने के बाद उसे WhatsApp चैट में संलग्न करें — इससे हमें स्थिति समझने में मदद मिलती है।",
      "submit": "WhatsApp से अनुरोध भेजें",
      "sending": "तैयार किया जा रहा है…",
      "successTitle": "अनुरोध तैयार है",
      "successBody": "आपके विवरण के साथ WhatsApp खुल रहा है। यदि उपयोगी हो तो चैट में फ़ोटो संलग्न करें।",
      "errorTitle": "कुछ गड़बड़ हो गई",
      "errorBody": "कृपया फिर से प्रयास करें या हमें सीधे WhatsApp पर संदेश भेजें।",
      "whatsappCta": "हमें WhatsApp करें",
      "emailCta": "हमें ईमेल भेजें",
      "photosCta": "WhatsApp पर फ़ोटो भेजें",
      "writingCta": "हमसे लिखित में संपर्क करें",
      "waMessage": "Hi! I need a locksmith. My situation: ",
      "waPhotoMessage": "Hi! I'm sending photos of my door, lock or vehicle. My location is: ",
      "waLabels": {
        "intro": "Hi! I need a locksmith.",
        "name": "नाम",
        "phone": "WhatsApp",
        "location": "स्थान",
        "issue": "आवश्यक मदद",
        "message": "क्या हुआ"
      },
      "validation": {
        "name": "कृपया अपना नाम दर्ज करें (कम से कम 2 अक्षर)",
        "phone": "कृपया एक मान्य WhatsApp नंबर दर्ज करें",
        "message": "कृपया बताएं क्या हुआ (कम से कम 5 अक्षर)"
      }
    },
    "footer": {
      "tagline": "Edinburgh, Glasgow और आसपास के क्षेत्रों में 24/7 आपातकालीन लॉकस्मिथ सहायता। लिखित WhatsApp सहायता।",
      "contactTitle": "संपर्क",
      "coverageTitle": "सेवा क्षेत्र",
      "aboutTitle": "हमारे बारे में",
      "legal": "स्वतंत्र एकल व्यापारी लॉकस्मिथ सेवा।",
      "legal2": "UNLockSmiths एक स्वतंत्र स्व-रोज़गार लॉकस्मिथ सेवा है जो Edinburgh और आसपास के क्षेत्रों में सेवा देती है।",
      "rights": "सर्वाधिकार सुरक्षित।",
      "website": "वेबसाइट"
    },
    "social": {
      "title": "हमें फ़ॉलो करें और संदेश भेजें",
      "sub": "हम Edinburgh, Glasgow और आसपास के क्षेत्रों में आपातकालीन लॉकस्मिथ सेवाओं के लिए दिन में 24 घंटे, सप्ताह में 7 दिन उपलब्ध हैं।"
    },
    "chat": {
      "title": "UNLockSmiths सहायक",
      "subtitle": "ऑनलाइन — 24/7 जवाब",
      "welcome": "नमस्ते! मैं UNLockSmiths सहायक हूँ। मुझसे कुछ भी पूछें: सेवाएँ, क्षेत्र, उपलब्धता…",
      "suggestions": [
        "क्या आप अभी उपलब्ध हैं?",
        "क्या आप मेरे क्षेत्र को कवर करते हैं?",
        "मैं सहायता का अनुरोध कैसे करूँ?"
      ],
      "placeholder": "अपना सवाल टाइप करें…",
      "error": "माफ़ कीजिए, कुछ गड़बड़ हो गई। फिर से कोशिश करें या हमें WhatsApp पर संदेश भेजें।",
      "open": "हमारे सहायक से चैट करें"
    },
    "float": {
      "label": "हमें WhatsApp पर संदेश भेजें",
      "waMessage": "Hi! I need a locksmith. My situation: "
    },
    "video": {
      "title": "बाहर बंद हो गए? मदद बस एक संदेश दूर है।",
      "sub": "20 सेकंड में देखें कैसे काम करता है: WhatsApp पर संदेश भेजें, अपनी लोकेशन और फ़ोटो भेजें, और काम शुरू होने से पहले लिखित में कीमत तय करें।",
      "unmute": "आवाज़ चालू करें",
      "mute": "म्यूट",
      "aria": "UNLockSmiths प्रोमो वीडियो: एडिनबरा में 24/7 आपातकालीन तालासाज़ — WhatsApp पर संदेश भेजें"
    },
    "aboutMe": {
      "label": "मेरे बारे में",
      "title": "अपने तालासाज़ से मिलें",
      "quote": "नमस्ते, मैं Alfonso हूँ, एडिनबरा में आपका स्थानीय तालासाज़। काम शुरू करने से पहले मैं आपके साथ लिखित में कीमत तय करता हूँ, ताकि कोई आश्चर्य न हो।"
    }
  },
};
